<template>
  <v-dialog
    v-model="navigation.sendCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignsViewDialogIsVisible"
    @contextmenu.prevent="null"
    :max-width="navigation.fullScreen ? '100vw' : '80vw'"
    :fullscreen="navigation.fullScreen"
    :retain-focus="false"
    scrim="black"
    opacity="0.8"
    style="user-select: none; cursor: default;"
  >
    <v-card 
      :style="navigation.fullScreen ? 'min-height: 100vh; height: 100vh; max-height: 100vh;' : (loader.sendCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignsView ? 'min-height: 95vh; height: 95vh; max-height: 95vh;' : 'min-height: 0; height: auto; max-height: 95vh;')"
      style="display: flex; flex-direction: column; overflow: hidden;"
    >
      <v-card color="primary" rounded="0" elevation="0" class="headerCard">
        <div class="titleContainer">
          <v-icon color="indigo" size="large">mdi-account-group</v-icon>
          <v-icon color="indigo">mdi-bullhorn</v-icon>
          <v-icon color="indigo" size="small" style="margin-right: 10px;">mdi-send</v-icon>
          <h3>{{ navigation.CRMWhatsappMarketingCampaignTab == 'Enviar' ? 'ENVIAR' : 'REENVIAR' }} CAMPAÑA DE MARKETING</h3>
        </div>
        <div class="actionsContainer">
          <v-btn 
            @click="navigation.sendCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignsViewDialogIsVisible = false"
            :disabled="loader.startup"
            color="error" 
            class="hoverableVButton" 
          >
            <v-icon size="small" start>mdi-close-circle</v-icon>
            <p>CERRAR</p>
          </v-btn>
        </div>
      </v-card>
      <v-card color="indigo" elevation="0" rounded="0" style="width: 100%; height: 2px; flex-shrink: 0;"></v-card>
      <template v-if="loader.sendCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignsView">
        <div style="flex: 1; min-height: 0; display: flex; flex-direction: column; align-items: center; justify-content: center;">
          <AppLoaderScreen
            :appLogoSize="'x-small'"
            :loadingText="`${navigation.CRMWhatsappMarketingCampaignTab == 'Enviar' ? 'Enviando' : 'Reenviando'} campaña de marketing a ${input.CRMWhatsappContactToSend.length} contacto${input.CRMWhatsappContactToSend.length > 1 ? 's' : ''}`"
            :dotsToAnimate="3"
            style="width: 100%; height: 100%;"
          ></AppLoaderScreen>
        </div>
      </template>
      <template v-else>
        <div style="flex: 1; min-height: 0; overflow-y: auto; scrollbar-width: thin; scrollbar-color: #3F51B5 transparent; padding: 15px;">
          <v-card elevation="2" style="border: 2px solid #343A40;">
            <v-card color="primary" elevation="0" rounded="0" style="padding: 10px;">
              <div style="display: flex; align-items: center; gap: 10px;">
                <v-icon color="indigo">mdi-account-group</v-icon>
                <p><strong>Contactos a {{ navigation.CRMWhatsappMarketingCampaignTab == 'Enviar' ? 'enviar' : 'reenviar' }}</strong></p>
              </div>
            </v-card>
            <v-card elevation="0" rounded="0" color="indigo" style="height: 2px;"></v-card>
            <v-data-table
              :headers="computed_CRMWhatsappContactToSendHeaders"
              :items="input.CRMWhatsappContactToSend"
              :hover="input.CRMWhatsappContactToSend.length > 1"
              :items-per-page="navigation.CRMWhatsappContactToSendLimit"
              :page="input.CRMWhatsappContactToSendPage"
              fixed-header
              style="max-height: 500px; overflow-y: auto; scrollbar-width: thin; scrollbar-color: #3F51B5 transparent;"
            >
              <template v-slot:headers="{ columns }">
                <tr>
                  <template
                    v-for="column in columns"
                    :key="column.value"
                  >
                    <th>
                      <v-card elevation="0" rounded="0" style="display: flex; align-items: center; white-space: nowrap; height: 58px; width: 100%; padding: 0px 25px;">
                        <template v-if="computed_CRMWhatsappContactToSendHeaders.find(header => header.value == column.value).value != 'select'">
                          <template v-if="computed_CRMWhatsappContactToSendHeaders.find(header => header.value == column.value).index > 1">
                            <v-icon 
                              @click="updateTableHeaderIndex('CRMWhatsappContactToSend', column.value, -1)"
                              color="tertiary"
                              size="x-small"
                              class="hoverableVIcon"
                              style="margin-right: 10px;"
                            >
                              mdi-arrow-left-bold
                            </v-icon>
                          </template>
                          <v-icon color="indigo" style="margin-right: 5px;">{{ computed_CRMWhatsappContactToSendHeaders.find(header => header.value == column.value).icon }}</v-icon>
                          <template v-if="computed_CRMWhatsappContactToSendHeaders.find(header => header.value == column.value).visible">
                            <p style="margin-right: 5px; display: flex; align-items: center;"><strong>{{ computed_CRMWhatsappContactToSendHeaders.find(header => header.value == column.value).title }}</strong></p>
                          </template>
                          <v-icon 
                            @click="computed_CRMWhatsappContactToSendHeaders.find(header => header.value == column.value).visible = !computed_CRMWhatsappContactToSendHeaders.find(header => header.value == column.value).visible; updateTableVisibility('CRMWhatsappContactToSend')"
                            color="tertiary"
                            size="x-small"
                            class="hoverableVIcon"
                          >
                            mdi-{{ computed_CRMWhatsappContactToSendHeaders.find(header => header.value == column.value).visible ? 'eye' : 'eye-off' }}
                          </v-icon>
                          <template v-if="computed_CRMWhatsappContactToSendHeaders.find(header => header.value == column.value).index < computed_CRMWhatsappContactToSendHeaders.length - 1">
                            <v-icon
                              @click="updateTableHeaderIndex('CRMWhatsappContactToSend', column.value, 1)"
                              color="tertiary"
                              size="x-small"
                              class="hoverableVIcon"
                              style="margin-left: 10px"
                            >
                              mdi-arrow-right-bold
                            </v-icon>
                          </template>
                        </template>
                      </v-card>
                      <v-card color="secondary-lighten-2" elevation="0" rounded="0" style="height: 1px;"></v-card>
                    </th>
                  </template>
                </tr>
              </template>
              <template v-slot:item="row">
                <tr>
                  <template
                    v-for="header in computed_CRMWhatsappContactToSendHeaders"
                    :key="header.value"
                  >
                    <td>
                      <template v-if="header.value == 'select' && computed_CRMWhatsappContactToSendHeaders.find(currentCRMWhatsappContactToSendHeader => currentCRMWhatsappContactToSendHeader.value == header.value).visible">
                        <template v-if="input.CRMWhatsappContactToSend.length > 1">
                          <v-hover>
                            <template v-slot="{ isHovering, props: hoverProps }">
                              <template v-if="isHovering == true && !systemInformationData.tooltipDisabled">
                                <v-tooltip text="Eliminar contacto de la lista de contactos a enviar" location="top">
                                  <template v-slot:activator="{ props: tooltipProps }">
                                    <v-icon
                                      v-bind="tooltipProps"
                                      @click="input.CRMWhatsappContactToSend = input.CRMWhatsappContactToSend.filter(currentCRMWhatsappContactToSend => currentCRMWhatsappContactToSend.CRMWhatsappContactID != row.item.CRMWhatsappContactID)"
                                      color="error"
                                      class="hoverableVIcon"
                                    >
                                      mdi-delete
                                    </v-icon>
                                  </template>
                                </v-tooltip>
                              </template>
                              <template v-else>
                                <v-icon
                                  v-bind="hoverProps"
                                  @click="input.CRMWhatsappContactToSend = input.CRMWhatsappContactToSend.filter(currentCRMWhatsappContactToSend => currentCRMWhatsappContactToSend.CRMWhatsappContactID != row.item.CRMWhatsappContactID)"
                                  color="error"
                                  class="hoverableVIcon"
                                >
                                  mdi-delete
                                </v-icon>
                              </template>
                            </template>
                          </v-hover>
                        </template>
                      </template>
                      <template v-else-if="header.value == 'CRMWhatsappContactID' && computed_CRMWhatsappContactToSendHeaders.find(currentCRMWhatsappContactToSendHeader => currentCRMWhatsappContactToSendHeader.value == header.value).visible">
                        <v-hover>
                          <template v-slot="{ isHovering, props: hoverProps }">
                            <template v-if="isHovering == true && !systemInformationData.tooltipDisabled">
                              <v-tooltip text="Copiar ID del contacto al portapapeles" location="top">
                                <template v-slot:activator="{ props: tooltipProps }">
                                  <p 
                                    v-bind="tooltipProps"
                                    @click="$generalFunctions.default.copyToClipboardWithoutTitle(this, 'ID del contacto', 'o', row.item.CRMWhatsappContactID)"
                                    class="hoverableVIcon"
                                    style="color: #3F51B5;"
                                  >
                                    <strong>{{ row.item.CRMWhatsappContactID }}</strong>
                                  </p>
                                </template>
                              </v-tooltip>
                            </template>
                            <template v-else>
                              <p
                                v-bind="hoverProps"
                                @click="$generalFunctions.default.copyToClipboardWithoutTitle(this, 'ID del contacto', 'o', row.item.CRMWhatsappContactID)"
                                class="hoverableVIcon"
                                style="color: #3F51B5;"
                              >
                                <strong>{{ row.item.CRMWhatsappContactID }}</strong>
                              </p>
                            </template>
                          </template>
                        </v-hover>
                      </template>
                      <template v-else-if="header.value == 'CRMWhatsappContact' && computed_CRMWhatsappContactToSendHeaders.find(currentCRMWhatsappContactToSendHeader => currentCRMWhatsappContactToSendHeader.value == header.value).visible">
                        <p style="white-space: nowrap;">{{ $displayFunctions.default.parseCRMWhatsappContactNameToDisplay(row.item) }}</p>
                        <p style="font-size: small; color: #9e9e9e; white-space: nowrap;">{{ $displayFunctions.default.fromPhoneNumberToCountryCodePhoneNumberCountryFlag(row.item.CRMWhatsappContactPhoneNumber, false) }}</p>
                      </template>
                      <template v-else-if="header.value == 'CRMWhatsappContactCRMLocality' && computed_CRMWhatsappContactToSendHeaders.find(currentCRMWhatsappContactToSendHeader => currentCRMWhatsappContactToSendHeader.value == header.value).visible">
                        <template v-if="row.item.CRMWhatsappContactCRMLocalityID == null">
                          <p style="font-size: x-small; color: #9e9e9e; white-space: nowrap;">No registrada</p>
                        </template>
                        <template v-else>
                          <v-chip
                            :color="systemInformationData.CRMLocalities.find(CRMLocality => CRMLocality.CRMLocalityID == row.item.CRMWhatsappContactCRMLocalityID) ? systemInformationData.CRMLocalities.find(CRMLocality => CRMLocality.CRMLocalityID == row.item.CRMWhatsappContactCRMLocalityID).CRMLocalityColor || 'primary' : 'primary'"
                            variant="flat"
                            elevation="2"
                            density="compact"
                            label
                          >
                            <p>{{ systemInformationData.CRMLocalities.find(CRMLocality => CRMLocality.CRMLocalityID == row.item.CRMWhatsappContactCRMLocalityID) ? systemInformationData.CRMLocalities.find(CRMLocality => CRMLocality.CRMLocalityID == row.item.CRMWhatsappContactCRMLocalityID).CRMLocalityName || 'No registrada' : 'No registrada' }}</p>
                          </v-chip>
                        </template>
                      </template>
                      <template v-else-if="header.value == 'lastCRMWhatsappConversationStartDatetime' && computed_CRMWhatsappContactToSendHeaders.find(currentCRMWhatsappContactToSendHeader => currentCRMWhatsappContactToSendHeader.value == header.value).visible">
                        <template v-if="row.item.lastCRMWhatsappConversationStartDatetime == null || row.item.lastCRMWhatsappConversationStartDatetimeTranscurredSeconds == null">
                          <p style="font-size: x-small; color: #9e9e9e; white-space: nowrap;">No registrado</p>
                        </template>
                        <template v-else>
                          <p style="white-space: nowrap;">{{ $displayFunctions.default.fromDatetimeToHHMMSSDDMMYYYY(row.item.lastCRMWhatsappConversationStartDatetime) }}</p>
                          <p style="font-size: x-small; color: #9e9e9e; white-space: nowrap;">(hace {{ $displayFunctions.default.fromSecondsToDaysHHMMSS(row.item.lastCRMWhatsappConversationStartDatetimeTranscurredSeconds) }})</p>
                        </template>
                      </template>
                      <template v-else-if="header.value == 'lastCRMWhatsappInvoiceCreationDatetime' && computed_CRMWhatsappContactToSendHeaders.find(currentCRMWhatsappContactToSendHeader => currentCRMWhatsappContactToSendHeader.value == header.value).visible">
                        <template v-if="row.item.lastCRMWhatsappInvoiceCreationDatetime == null || row.item.lastCRMWhatsappInvoiceCreationDatetimeTranscurredSeconds == null">
                          <p style="font-size: x-small; color: #9e9e9e; white-space: nowrap;">No registrado</p>
                        </template>
                        <template v-else>
                          <p style="white-space: nowrap;">{{ $displayFunctions.default.fromDatetimeToHHMMSSDDMMYYYY(row.item.lastCRMWhatsappInvoiceCreationDatetime) }}</p>
                          <p style="font-size: x-small; color: #9e9e9e; white-space: nowrap;">(hace {{ $displayFunctions.default.fromSecondsToDaysHHMMSS(row.item.lastCRMWhatsappInvoiceCreationDatetimeTranscurredSeconds) }})</p>
                        </template>
                      </template>
                      <template v-else-if="header.value == 'CRMWhatsappMarketingCampaignMessageCount' && computed_CRMWhatsappContactToSendHeaders.find(currentCRMWhatsappContactToSendHeader => currentCRMWhatsappContactToSendHeader.value == header.value).visible">
                        <p style="white-space: nowrap;">{{ $displayFunctions.default.parseAmountToDisplayWithoutDecimals(row.item.CRMWhatsappMarketingCampaignMessageCount) }}</p>
                      </template>
                    </td>
                  </template>
                </tr>
              </template>
              <template v-slot:bottom></template>
            </v-data-table>
            <v-card elevation="0" rounded="0" color="indigo" style="height: 2px;"></v-card>
            <v-card elevation="0" rounded="0" color="primary" style="padding: 15px;">
              <div class="paginationContainer">
                <v-pagination
                  v-model="input.CRMWhatsappContactToSendPage"
                  :length="Math.ceil(input.CRMWhatsappContactToSend.length / navigation.CRMWhatsappContactToSendLimit)"
                  :total-visible="3"
                  density="compact"
                  size="small"
                ></v-pagination>
                <p style="font-size: x-small;">{{ (input.CRMWhatsappContactToSend.length == 0) ? `0 de 0 contactos` : `${(input.CRMWhatsappContactToSendPage - 1) * navigation.CRMWhatsappContactToSendLimit + 1} - ${Math.min(input.CRMWhatsappContactToSendPage * navigation.CRMWhatsappContactToSendLimit, input.CRMWhatsappContactToSend.length)} de ${input.CRMWhatsappContactToSend.length} ${input.CRMWhatsappContactToSend.length > 1 ? 'contactos' : 'contacto'}`}}</p>
              </div>
            </v-card>
          </v-card>
          <div style="display: flex; gap: 5px; margin-top: 15px;">
            <v-icon color="indigo">mdi-message-text</v-icon>
            <p style="max-height: 150px; overflow-y: auto; scrollbar-width: thin; scrollbar-color: #3F51B5 transparent;"><strong>Contenido del mensaje de texto:</strong> {{ display.currentCRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignCRMWhatsappTextMessageContent }}</p>
          </div>
          <div style="display: flex; gap: 5px; margin-top: 15px;">
            <v-icon color="indigo">mdi-cash-minus</v-icon>
            <p style="max-height: 150px; overflow-y: auto; scrollbar-width: thin; scrollbar-color: #3F51B5 transparent;"><strong>Costo de envío aproximado:</strong> {{ $displayFunctions.default.parseAmountToDisplay(0.01 * input.CRMWhatsappContactToSend.length) }} <span style="color: #3F51B5;"><strong>USD</strong></span></p>
          </div>
        </div>
        <v-card color="indigo" elevation="0" rounded="0" style="width: 100%; height: 2px; flex-shrink: 0;"></v-card>
        <v-card color="primary" elevation="0" rounded="0" style="padding: 15px; flex-shrink: 0;">
          <v-btn 
            @click="sendCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignsView()" 
            :disabled="loader.startup || loader.sendCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignsView" 
            color="indigo" 
            block 
            class="hoverableVButton"
          >
            <v-icon start>mdi-account-group</v-icon>
            <v-icon start>mdi-bullhorn</v-icon>
            <v-icon start>mdi-send</v-icon>
            <h3>{{ navigation.CRMWhatsappMarketingCampaignTab == 'Enviar' ? 'ENVIAR' : 'REENVIAR' }} A {{ input.CRMWhatsappContactToSend.length }} CONTACTO{{ input.CRMWhatsappContactToSend.length > 1 ? 'S' : '' }}</h3>
          </v-btn>
        </v-card>
      </template>
    </v-card>
  </v-dialog>
  <v-menu
    v-model="navigation.contextMenuIsVisible"
    @update:model-value="navigation.contextMenuIsVisible == false ? navigation.contextMenuItem = null : null"
    @contextmenu.prevent="navigation.contextMenuIsVisible = false; navigation.contextMenuItem = null;"
    :activator="false"
    location-strategy="static"
    transition="scroll-y-transition"
    scrim="black"
    opacity="0.8"
    style="user-select: none; cursor: default;"
  >
    <v-list
      :style="`top: ${navigation.contextMenuY}px; left: ${navigation.contextMenuX}px;`"
      density="compact"
      style="position: absolute; width: 550px; height: auto; max-height: 400px; overflow-x: hidden; overflow-y: auto; scrollbar-width: thin; scrollbar-color: #3F51B5 transparent;" 
    >
      <template v-if="navigation.contextMenuItem && navigation.contextMenuItem.type == 'CRMWhatsappMarketingCampaign'">
        <v-list-item
          @click="$generalFunctions.default.copyToClipboardWithoutTitle(this, 'ID de la campaña de marketing', 'o', navigation.contextMenuItem.CRMWhatsappMarketingCampaignID);"
          title="Copiar ID de la campaña de marketing"
          class="hoverableVListItem"
        >
          <template v-slot:prepend>
            <v-icon color="indigo">mdi-account-group</v-icon>
            <v-icon color="indigo">mdi-bullhorn</v-icon>
            <v-icon color="indigo" size="x-small">mdi-barcode</v-icon>
          </template>
        </v-list-item>
        <v-list-item
          @click="$root.dialogComponent.openCRMWhatsappMarketingCampaignDialog('update', (() => this.selectCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignsView(true)), navigation.contextMenuItem.CRMWhatsappMarketingCampaignID)"
          title="Actualizar campaña de marketing"
          class="hoverableVListItem"
        >
          <template v-slot:prepend>
            <v-icon color="indigo">mdi-account-group</v-icon>
            <v-icon color="indigo">mdi-bullhorn</v-icon>
            <v-icon color="indigo" size="small">mdi-pencil</v-icon>
          </template>
        </v-list-item>
        <v-list-item
          @click="$root.dialogComponent.openCRMWhatsappMarketingCampaignDialog('delete', (() => this.selectCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignsView(true)), navigation.contextMenuItem.CRMWhatsappMarketingCampaignID)"
          title="Eliminar campaña de marketing"
          class="hoverableVListItem"
        >
          <template v-slot:prepend>
            <v-icon color="indigo">mdi-account-group</v-icon>
            <v-icon color="indigo">mdi-bullhorn</v-icon>
            <v-icon color="indigo" size="small">mdi-delete</v-icon>
          </template>
        </v-list-item>
      </template>
    </v-list>
  </v-menu>
  <div
    @contextmenu.prevent="null"
    style="min-width: 100%; width: 100%; max-width: 100%; min-height: 100vh; height: 100vh; max-height: 100vh; overflow: hidden; user-select: none; cursor: default;"
  >
    <template v-if="loader.startup">
      <AppLoaderScreen
        :appLogoSize="'x-small'"
        :loadingText="'Cargando campañas de marketing'"
        :dotsToAnimate="3"
      ></AppLoaderScreen>
    </template>
    <template v-else>
      <div class="mainContainer">
        <v-card elevation="0" rounded="0" color="border" class="navigationContainer">
          <v-card
            :style="display.currentCRMWhatsappMarketingCampaign == null || $vuetify.display.width < 1200 ? null : 'border-right: 2px solid #9e9e9e;'"
            elevation="0"
            rounded="0"
            color="primary"
            style="width: 100%; height: 60px; padding: 15px; display: flex; align-items: center; flex-shrink: 0;"
          >
            <v-icon size="large" color="indigo">mdi-account-group</v-icon>
            <v-icon color="indigo" style="margin-right: 10px;">mdi-bullhorn</v-icon>
            <h4>CAMPAÑAS DE MARKETING</h4>
          </v-card>
          <v-card elevation="0" rounded="0" color="indigo" style="width: 100%; height: 2px; flex-shrink: 0;"></v-card>
          <div class="navigationContentContainer">
            <template v-if="computed_CRMWhatsappMarketingCampaignCount > 0">
              <template
                v-for="currentCRMWhatsappMarketingCampaign in computed_CRMWhatsappMarketingCampaign"
                :key="currentCRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignID"
              >
                <v-list bgColor="border" density="compact" style="overflow: hidden; padding: 0; margin: 0;">
                  <v-list-item
                    @click="(display.currentCRMWhatsappMarketingCampaign != null && currentCRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignID == display.currentCRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignID) ? null : selectCRMWhatsappMarketingCampaignDetailFromCRMWhatsappMarketingCampaignsView(currentCRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignID)"
                    @contextmenu="navigation.contextMenuIsVisible = true; navigation.contextMenuY = $event.clientY; navigation.contextMenuX = $event.clientX; navigation.contextMenuItem = {'type': 'CRMWhatsappMarketingCampaign', ...currentCRMWhatsappMarketingCampaign};"
                    :active="navigation.currentCRMWhatsappMarketingCampaignID == currentCRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignID"
                    :disabled="loader.selectCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignsView"
                    :class="loader.selectCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignsView ? 'loadingVDataTableRow' : (navigation.contextMenuItem != null && navigation.contextMenuItem.CRMWhatsappMarketingCampaignID == currentCRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignID ? 'selectedVDataTableRow' : null)"
                    style="border-bottom: 2px solid #c4c4c4;"
                    class="hoverableVListItem"
                  >
                    <div style="display: flex; align-items: center; gap: 10px;">
                      <p
                        :style="navigation.currentCRMWhatsappMarketingCampaignID == currentCRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignID ? 'font-weight: bold;' : null"
                      >
                        {{ currentCRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignName }}
                      </p>
                      <div style="margin-left: auto; display: flex; flex-direction: column; gap: 10px; margin-top: 5px; margin-bottom: 5px;">
                        <div style="margin-left: auto;">
                          <v-chip
                            :color="{'Difusión': 'teal', 'Promoción': 'info', 'Código de descuento': 'warning', 'Otro': 'blue-secondary'}[currentCRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignType]"
                            variant="flat"
                            density="compact"
                            elevation="2"
                            label
                          >
                            <p>{{ currentCRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignType }}</p>
                          </v-chip>
                        </div>
                        <div style="margin-left: auto;">
                          <v-chip
                            :color="{'Activa': 'success', 'Inactiva': 'secondary', 'Finalizada': 'error'}[currentCRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignStatus]"
                            variant="flat"
                            density="compact"
                            elevation="2"
                            label
                          >
                            <p>{{ currentCRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignStatus }}</p>
                          </v-chip>
                        </div>
                        <template v-if="currentCRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignCRMLocalityID != null">
                          <div style="margin-left: auto;">
                            <v-chip
                              :color="currentCRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignCRMLocalityColor || 'primary'"
                              variant="flat"
                              density="compact"
                              elevation="2"
                              label
                            >
                              <p>{{ currentCRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignCRMLocalityName || 'No registrada' }}</p>
                            </v-chip>
                          </div>
                        </template>
                      </div>
                    </div>
                  </v-list-item>
                </v-list>
              </template>
            </template>
            <template v-else>
              <div class="navigationNoContentContainer">
                <v-icon color="indigo">mdi-information</v-icon>
                <p style="margin-top: 5px; color: #9e9e9e;">No se encontraron campañas de marketing</p>
                <v-btn
                  @click="$root.dialogComponent.openCRMWhatsappMarketingCampaignDialog('insert', (() => this.selectCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignsView(true)), null)"
                  color="indigo"
                  class="hoverableVButton"
                  density="compact"
                  style="margin-top: 15px;"
                >
                  <v-icon size="small" start>mdi-plus-circle</v-icon>
                  <p style="font-size: small;">CREAR</p>
                </v-btn>
              </div>
            </template>
          </div>
          <template v-if="computed_CRMWhatsappMarketingCampaignCount > 0">
            <v-card elevation="0" rounded="0" color="indigo" style="width: 100%; height: 2px; flex-shrink: 0;"></v-card>
            <v-card
              elevation="0"
              rounded="0"
              color="primary"
              :style="$vuetify.display.width < 1200 ? 'width: 100%; display: flex; flex-direction: column; align-items: center; flex-shrink: 0; padding: 15px; gap: 10px;' : (display.currentCRMWhatsappMarketingCampaign == null ? 'width: 100%; height: 60px; display: flex; align-items: center; flex-shrink: 0; padding: 0px 15px;' : 'width: 100%; height: 60px; display: flex; align-items: center; flex-shrink: 0; padding: 0px 15px; border-right: 2px solid #9e9e9e;')"
            >
              <div>
                <v-menu
                  @contextmenu.prevent="null"
                  v-model="navigation.mainMenuIsVisible"
                  :close-on-content-click="false"
                  transition="scroll-y-transition"
                  scrim="black"
                  opacity="0.8"
                  style="user-select: none; cursor: default;"
                >
                  <template v-slot:activator="{ props: mainMenuProps }">
                    <v-btn
                      v-bind="mainMenuProps"
                      color="secondary"
                      density="compact"
                      class="hoverableVButton"
                    >
                      <v-icon start>mdi-dots-vertical</v-icon>
                      <p style="font-size: small;">ACCIONES</p>
                      <template v-if="input.CRMWhatsappMarketingCampaignName != null || input.CRMWhatsappMarketingCampaignDescription != null || input.CRMWhatsappMarketingCampaignType.length > 0 || input.allCRMWhatsappMarketingCampaignTypeSelected || input.CRMWhatsappMarketingCampaignStatus.length > 0 || input.allCRMWhatsappMarketingCampaignStatusSelected || input.CRMWhatsappMarketingCampaignCRMLocalityID.length > 0 || input.allCRMWhatsappMarketingCampaignCRMLocalityIDSelected || input.CRMWhatsappMarketingCampaignCRMWhatsappTextMessageContent != null">
                        <v-icon color="error" end class="pulseElement">mdi-alert-circle</v-icon>
                      </template>
                    </v-btn>
                  </template>
                  <v-list density="compact" style="overflow-x: hidden; overflow-y: auto; scrollbar-width: thin; scrollbar-color: #3F51B5 transparent;">
                    <v-list-item
                      @click="$root.dialogComponent.openCRMWhatsappMarketingCampaignDialog('insert', (() => this.selectCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignsView(true)), null); navigation.mainMenuIsVisible = false;"
                      title="Crear campaña de marketing"
                      class="hoverableVListItem"
                    >
                      <template v-slot:prepend>
                        <v-icon color="indigo">mdi-plus-circle</v-icon>
                      </template>
                    </v-list-item>
                    <v-menu
                      @contextmenu.prevent="null"
                      :close-on-content-click="false"
                      transition="scroll-y-transition"
                      location="end"
                      style="user-select: none; cursor: default;"
                    >
                      <template v-slot:activator="{ props: searchMenuProps }">
                        <v-list-item
                          v-bind="searchMenuProps"
                          title="Filtrar campañas de marketing"
                          class="hoverableVListItem"
                        >
                          <template v-slot:prepend>
                            <v-icon color="indigo">mdi-filter-variant</v-icon>
                          </template>
                          <template v-slot:append>
                            <template v-if="input.CRMWhatsappMarketingCampaignName != null || input.CRMWhatsappMarketingCampaignDescription != null || input.CRMWhatsappMarketingCampaignType.length > 0 || input.allCRMWhatsappMarketingCampaignTypeSelected || input.CRMWhatsappMarketingCampaignStatus.length > 0 || input.allCRMWhatsappMarketingCampaignStatusSelected || input.CRMWhatsappMarketingCampaignCRMLocalityID.length > 0 || input.allCRMWhatsappMarketingCampaignCRMLocalityIDSelected || input.CRMWhatsappMarketingCampaignCRMWhatsappTextMessageContent != null">
                              <v-icon color="error" end class="pulseElement">mdi-alert-circle</v-icon>
                            </template>
                            <v-icon size="small">mdi-chevron-right</v-icon>
                          </template>
                        </v-list-item>
                      </template>
                      <v-card style="width: 650px;">
                        <v-card color="primary" rounded="0" elevation="0" class="headerCard">
                          <div class="titleContainer">
                            <v-icon color="indigo" style="margin-right: 10px;">mdi-filter-variant</v-icon>
                            <p>FILTRAR CAMPAÑAS DE MARKETING</p>
                          </div>
                          <div class="actionsContainer">
                            <v-btn 
                              @click="navigation.mainMenuIsVisible = false"
                              color="error"
                              density="compact"
                              class="hoverableVButton" 
                            >
                              <v-icon start>mdi-close-circle</v-icon>
                              <p style="font-size: small;">CERRAR</p>
                            </v-btn>
                          </div>
                        </v-card>
                        <v-card color="indigo" elevation="0" rounded="0" style="width: 100%; height: 2px; flex-shrink: 0;"></v-card>
                        <div style="padding: 15px;">
                          <v-text-field
                            v-model="input.CRMWhatsappMarketingCampaignName"
                            :loading="loader.startup || loader.selectCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignsView"
                            :disabled="loader.startup || loader.selectCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignsView"
                            label="Filtrar por nombre"
                            prepend-inner-icon="mdi-alphabetical-variant"
                            clear-icon="mdi-backspace"
                            variant="outlined"
                            density="compact"
                            autocomplete="off"
                            clearable
                            hide-details
                            style="margin-bottom: 15px;"
                          ></v-text-field>
                          <v-textarea
                            v-model="input.CRMWhatsappMarketingCampaignDescription"
                            :loading="loader.startup || loader.selectCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignsView"
                            :disabled="loader.startup || loader.selectCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignsView"
                            label="Filtrar por descripción"
                            prepend-inner-icon="mdi-text-box"
                            clear-icon="mdi-backspace"
                            variant="outlined"
                            density="compact"
                            autocomplete="off"
                            rows="3"
                            max-rows="3"
                            no-resize
                            clearable
                            hide-details
                            style="margin-bottom: 15px;"
                          ></v-textarea>
                          <v-autocomplete
                            v-model="input.CRMWhatsappMarketingCampaignType"
                            @update:model-value="input.allCRMWhatsappMarketingCampaignTypeSelected = input.CRMWhatsappMarketingCampaignType.length == display.CRMWhatsappMarketingCampaignType.length;"
                            :items="display.CRMWhatsappMarketingCampaignType"
                            :loading="loader.startup || loader.selectCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignsView"
                            :disabled="loader.startup || loader.selectCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignsView"
                            label="Filtrar por tipo"
                            prepend-inner-icon="mdi-source-branch"
                            clear-icon="mdi-backspace"
                            variant="outlined"
                            density="compact"
                            autocomplete="off"
                            chips
                            multiple
                            closable-chips
                            clearable
                            hide-details
                            hide-no-data
                            style="margin-bottom: 15px;"
                          >
                            <template v-slot:chip="{ item, index }">
                              <template v-if="index < 3">
                                <v-chip 
                                  :color="item.raw.color"
                                  elevation="2"
                                  variant="flat"
                                  label
                                >
                                  <p>{{ item.raw.title }}</p>
                                  <template v-slot:close>
                                    <v-icon 
                                      @click="input.CRMWhatsappMarketingCampaignType = input.CRMWhatsappMarketingCampaignType.filter(currentCRMWhatsappMarketingCampaignType => currentCRMWhatsappMarketingCampaignType != item.value)"
                                      class="hoverableVIcon"
                                    >
                                      mdi-close-circle
                                    </v-icon>
                                  </template>
                                </v-chip>
                              </template>
                              <template v-else-if="index == 3">
                                <p style="color: #9e9e9e; font-size: small;">(+{{ input.CRMWhatsappMarketingCampaignType.length - 3 }} {{ input.CRMWhatsappMarketingCampaignType.length - 3 == 1 ? 'tipo' : 'tipos' }})</p>
                              </template>
                            </template>
                            <template v-slot:item="{ item, index }">
                              <template v-if="index == 0 && display.CRMWhatsappMarketingCampaignType.length > 1">
                                <v-list density="compact" style="overflow: hidden; padding: 0; margin: 0;">
                                  <v-list-item
                                    @click="input.allCRMWhatsappMarketingCampaignTypeSelected = !input.allCRMWhatsappMarketingCampaignTypeSelected; input.allCRMWhatsappMarketingCampaignTypeSelected ? input.CRMWhatsappMarketingCampaignType = display.CRMWhatsappMarketingCampaignType.map(currentCRMWhatsappMarketingCampaignType => currentCRMWhatsappMarketingCampaignType.value) : input.CRMWhatsappMarketingCampaignType.length = 0;"
                                    :title="null" 
                                    :subtitle="null"
                                    :active="input.allCRMWhatsappMarketingCampaignTypeSelected"
                                    class="hoverableVListItem"
                                  >
                                    <template v-slot:prepend>
                                      <v-switch
                                        :model-value="input.allCRMWhatsappMarketingCampaignTypeSelected"
                                        density="compact"
                                        color="indigo"
                                        readonly
                                        hide-details
                                        class="hoverableVIcon"
                                        style="margin-right: 20px;"
                                      ></v-switch>
                                      <template v-if="input.allCRMWhatsappMarketingCampaignTypeSelected">
                                        <p>Deseleccionar todos los tipos</p>
                                      </template>
                                      <template v-else>
                                        <p>Seleccionar {{ (display.CRMWhatsappMarketingCampaignType.length - input.CRMWhatsappMarketingCampaignType.length) == 1 ? 'el' : 'los' }}{{ (display.CRMWhatsappMarketingCampaignType.length - input.CRMWhatsappMarketingCampaignType.length) > 1 ? ` ${(display.CRMWhatsappMarketingCampaignType.length - input.CRMWhatsappMarketingCampaignType.length)}` : '' }} tipo{{ (display.CRMWhatsappMarketingCampaignType.length - input.CRMWhatsappMarketingCampaignType.length) == 1 ? '' : 's' }} restante{{ (display.CRMWhatsappMarketingCampaignType.length - input.CRMWhatsappMarketingCampaignType.length) == 1 ? '' : 's' }}</p>
                                      </template>
                                    </template>
                                  </v-list-item>
                                </v-list>
                              </template>
                              <v-list density="compact" style="overflow: hidden; padding: 0; margin: 0;">
                                <v-list-item 
                                  @click="input.CRMWhatsappMarketingCampaignType.includes(item.value) ? input.CRMWhatsappMarketingCampaignType = input.CRMWhatsappMarketingCampaignType.filter(currentCRMWhatsappMarketingCampaignType => currentCRMWhatsappMarketingCampaignType != item.value) : input.CRMWhatsappMarketingCampaignType.push(item.value); input.allCRMWhatsappMarketingCampaignTypeSelected = input.CRMWhatsappMarketingCampaignType.length == display.CRMWhatsappMarketingCampaignType.length;"
                                  :title="null" 
                                  :subtitle="null"
                                  :active="input.CRMWhatsappMarketingCampaignType.includes(item.value)"
                                  class="hoverableVListItem"
                                >
                                  <template v-slot:prepend>
                                    <v-checkbox-btn 
                                      :model-value="input.CRMWhatsappMarketingCampaignType.includes(item.value)"
                                      density="compact"
                                      readonly
                                      hide-details
                                      class="hoverableVIcon"
                                      style="margin-right: 10px;"
                                    ></v-checkbox-btn>
                                  </template>
                                  <v-chip 
                                    :color="item.raw.color"
                                    density="dense"
                                    variant="flat"
                                    elevation="2"
                                    label
                                    style="margin-top: 5px; margin-bottom: 5px;"
                                  >
                                    <p>{{ item.raw.title }}</p>
                                  </v-chip>
                                </v-list-item>
                              </v-list>
                            </template>
                          </v-autocomplete>
                          <v-autocomplete
                            v-model="input.CRMWhatsappMarketingCampaignStatus"
                            @update:model-value="input.allCRMWhatsappMarketingCampaignStatusSelected = input.CRMWhatsappMarketingCampaignStatus.length == display.CRMWhatsappMarketingCampaignStatus.length;"
                            :items="display.CRMWhatsappMarketingCampaignStatus"
                            :loading="loader.startup || loader.selectCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignsView"
                            :disabled="loader.startup || loader.selectCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignsView"
                            label="Filtrar por estado"
                            prepend-inner-icon="mdi-clock"
                            clear-icon="mdi-backspace"
                            variant="outlined"
                            density="compact"
                            autocomplete="off"
                            chips
                            multiple
                            closable-chips
                            clearable
                            hide-details
                            hide-no-data
                            style="margin-bottom: 15px;"
                          >
                            <template v-slot:chip="{ item, index }">
                              <template v-if="index < 3">
                                <v-chip 
                                  :color="item.raw.color"
                                  elevation="2"
                                  variant="flat"
                                  label
                                >
                                  <p>{{ item.raw.title }}</p>
                                  <template v-slot:close>
                                    <v-icon 
                                      @click="input.CRMWhatsappMarketingCampaignStatus = input.CRMWhatsappMarketingCampaignStatus.filter(currentCRMWhatsappMarketingCampaignStatus => currentCRMWhatsappMarketingCampaignStatus != item.value)"
                                      class="hoverableVIcon"
                                    >
                                      mdi-close-circle
                                    </v-icon>
                                  </template>
                                </v-chip>
                              </template>
                              <template v-else-if="index == 3">
                                <p style="color: #9e9e9e; font-size: small;">(+{{ input.CRMWhatsappMarketingCampaignStatus.length - 3 }} {{ input.CRMWhatsappMarketingCampaignStatus.length - 3 == 1 ? 'estado' : 'estados' }})</p>
                              </template>
                            </template>
                            <template v-slot:item="{ item, index }">
                              <template v-if="index == 0 && display.CRMWhatsappMarketingCampaignStatus.length > 1">
                                <v-list density="compact" style="overflow: hidden; padding: 0; margin: 0;">
                                  <v-list-item
                                    @click="input.allCRMWhatsappMarketingCampaignStatusSelected = !input.allCRMWhatsappMarketingCampaignStatusSelected; input.allCRMWhatsappMarketingCampaignStatusSelected ? input.CRMWhatsappMarketingCampaignStatus = display.CRMWhatsappMarketingCampaignStatus.map(currentCRMWhatsappMarketingCampaignStatus => currentCRMWhatsappMarketingCampaignStatus.value) : input.CRMWhatsappMarketingCampaignStatus.length = 0;"
                                    :title="null" 
                                    :subtitle="null"
                                    :active="input.allCRMWhatsappMarketingCampaignStatusSelected"
                                    class="hoverableVListItem"
                                  >
                                    <template v-slot:prepend>
                                      <v-switch
                                        :model-value="input.allCRMWhatsappMarketingCampaignStatusSelected"
                                        density="compact"
                                        color="indigo"
                                        readonly
                                        hide-details
                                        class="hoverableVIcon"
                                        style="margin-right: 20px;"
                                      ></v-switch>
                                      <template v-if="input.allCRMWhatsappMarketingCampaignStatusSelected">
                                        <p>Deseleccionar todos los estados</p>
                                      </template>
                                      <template v-else>
                                        <p>Seleccionar {{ (display.CRMWhatsappMarketingCampaignStatus.length - input.CRMWhatsappMarketingCampaignStatus.length) == 1 ? 'el' : 'los' }}{{ (display.CRMWhatsappMarketingCampaignStatus.length - input.CRMWhatsappMarketingCampaignStatus.length) > 1 ? ` ${(display.CRMWhatsappMarketingCampaignStatus.length - input.CRMWhatsappMarketingCampaignStatus.length)}` : '' }} estado{{ (display.CRMWhatsappMarketingCampaignStatus.length - input.CRMWhatsappMarketingCampaignStatus.length) == 1 ? '' : 's' }} restante{{ (display.CRMWhatsappMarketingCampaignStatus.length - input.CRMWhatsappMarketingCampaignStatus.length) == 1 ? '' : 's' }}</p>
                                      </template>
                                    </template>
                                  </v-list-item>
                                </v-list>
                              </template>
                              <v-list density="compact" style="overflow: hidden; padding: 0; margin: 0;">
                                <v-list-item 
                                  @click="input.CRMWhatsappMarketingCampaignStatus.includes(item.value) ? input.CRMWhatsappMarketingCampaignStatus = input.CRMWhatsappMarketingCampaignStatus.filter(currentCRMWhatsappMarketingCampaignStatus => currentCRMWhatsappMarketingCampaignStatus != item.value) : input.CRMWhatsappMarketingCampaignStatus.push(item.value); input.allCRMWhatsappMarketingCampaignStatusSelected = input.CRMWhatsappMarketingCampaignStatus.length == display.CRMWhatsappMarketingCampaignStatus.length;"
                                  :title="null" 
                                  :subtitle="null"
                                  :active="input.CRMWhatsappMarketingCampaignStatus.includes(item.value)"
                                  class="hoverableVListItem"
                                >
                                  <template v-slot:prepend>
                                    <v-checkbox-btn 
                                      :model-value="input.CRMWhatsappMarketingCampaignStatus.includes(item.value)"
                                      density="compact"
                                      readonly
                                      hide-details
                                      class="hoverableVIcon"
                                      style="margin-right: 10px;"
                                    ></v-checkbox-btn>
                                  </template>
                                  <v-chip 
                                    :color="item.raw.color"
                                    density="dense"
                                    variant="flat"
                                    elevation="2"
                                    label
                                    style="margin-top: 5px; margin-bottom: 5px;"
                                  >
                                    <p>{{ item.raw.title }}</p>
                                  </v-chip>
                                </v-list-item>
                              </v-list>
                            </template>
                          </v-autocomplete>
                          <v-autocomplete
                            v-model="input.CRMWhatsappMarketingCampaignCRMLocalityID"
                            @update:model-value="input.allCRMWhatsappMarketingCampaignCRMLocalityIDSelected = input.CRMWhatsappMarketingCampaignCRMLocalityID.length == display.CRMWhatsappMarketingCampaignCRMLocalityID.length;"
                            :items="systemInformationData.CRMLocalities"
                            :loading="loader.startup || loader.selectCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignsView"
                            :disabled="loader.startup || loader.selectCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignsView"
                            label="Filtrar por localidad"
                            prepend-inner-icon="mdi-store"
                            clear-icon="mdi-backspace"
                            item-value="CRMLocalityID"
                            item-title="CRMLocalityName"
                            variant="outlined"
                            density="compact"
                            autocomplete="off"
                            chips
                            multiple
                            closable-chips
                            clearable
                            hide-details
                            hide-no-data
                            style="margin-bottom: 15px;"
                          >
                            <template v-slot:chip="{ item, index }">
                              <template v-if="index < 3">
                                <v-chip 
                                  :color="systemInformationData.CRMLocalities.find(CRMLocality => CRMLocality.CRMLocalityID == item.value) ? systemInformationData.CRMLocalities.find(CRMLocality => CRMLocality.CRMLocalityID == item.value).CRMLocalityColor || 'primary' : 'primary'"
                                  elevation="2"
                                  variant="flat"
                                  label
                                >
                                  <p>{{ systemInformationData.CRMLocalities.find(CRMLocality => CRMLocality.CRMLocalityID == item.value) ? systemInformationData.CRMLocalities.find(CRMLocality => CRMLocality.CRMLocalityID == item.value).CRMLocalityName : 'No registrada' }}</p>
                                  <template v-slot:close>
                                    <v-icon 
                                      @click="input.CRMWhatsappMarketingCampaignCRMLocalityID = input.CRMWhatsappMarketingCampaignCRMLocalityID.filter(currentCRMWhatsappMarketingCampaignCRMLocalityID => currentCRMWhatsappMarketingCampaignCRMLocalityID != item.value)"
                                      class="hoverableVIcon"
                                    >
                                      mdi-close-circle
                                    </v-icon>
                                  </template>
                                </v-chip>
                              </template>
                              <template v-else-if="index == 3">
                                <p style="color: #9e9e9e; font-size: small;">(+{{ input.CRMWhatsappMarketingCampaignCRMLocalityID.length - 3 }} {{ input.CRMWhatsappMarketingCampaignCRMLocalityID.length - 3 == 1 ? 'localidad' : 'localidades' }})</p>
                              </template>
                            </template>
                            <template v-slot:item="{ item, index }">
                              <template v-if="index == 0 && systemInformationData.CRMLocalities.length > 1">
                                <v-list density="compact" style="overflow: hidden; padding: 0; margin: 0;">
                                  <v-list-item
                                    @click="input.allCRMWhatsappMarketingCampaignCRMLocalityIDSelected = !input.allCRMWhatsappMarketingCampaignCRMLocalityIDSelected; input.allCRMWhatsappMarketingCampaignCRMLocalityIDSelected ? input.CRMWhatsappMarketingCampaignCRMLocalityID = systemInformationData.CRMLocalities.map(currentCRMWhatsappMarketingCampaignCRMLocalityID => currentCRMWhatsappMarketingCampaignCRMLocalityID.CRMLocalityID) : input.CRMWhatsappMarketingCampaignCRMLocalityID.length = 0;"
                                    :title="null" 
                                    :subtitle="null"
                                    :active="input.allCRMWhatsappMarketingCampaignCRMLocalityIDSelected"
                                    class="hoverableVListItem"
                                  >
                                    <template v-slot:prepend>
                                      <v-switch
                                        :model-value="input.allCRMWhatsappMarketingCampaignCRMLocalityIDSelected"
                                        density="compact"
                                        color="indigo"
                                        readonly
                                        hide-details
                                        class="hoverableVIcon"
                                        style="margin-right: 20px;"
                                      ></v-switch>
                                      <template v-if="input.allCRMWhatsappMarketingCampaignCRMLocalityIDSelected">
                                        <p>Deseleccionar todas las localidades</p>
                                      </template>
                                      <template v-else>
                                        <p>Seleccionar {{ (systemInformationData.CRMLocalities.length - input.CRMWhatsappMarketingCampaignCRMLocalityID.length) == 1 ? 'la' : 'las' }}{{ (systemInformationData.CRMLocalities.length - input.CRMWhatsappMarketingCampaignCRMLocalityID.length) > 1 ? ` ${(systemInformationData.CRMLocalities.length - input.CRMWhatsappMarketingCampaignCRMLocalityID.length)}` : '' }} localidad{{ (systemInformationData.CRMLocalities.length - input.CRMWhatsappMarketingCampaignCRMLocalityID.length) == 1 ? '' : 'es' }} restante{{ (systemInformationData.CRMLocalities.length - input.CRMWhatsappMarketingCampaignCRMLocalityID.length) == 1 ? '' : 's' }}</p>
                                      </template>
                                    </template>
                                  </v-list-item>
                                </v-list>
                              </template>
                              <v-list density="compact" style="overflow: hidden; padding: 0; margin: 0;">
                                <v-list-item 
                                  @click="input.CRMWhatsappMarketingCampaignCRMLocalityID.includes(item.value) ? input.CRMWhatsappMarketingCampaignCRMLocalityID = input.CRMWhatsappMarketingCampaignCRMLocalityID.filter(currentCRMWhatsappMarketingCampaignCRMLocalityID => currentCRMWhatsappMarketingCampaignCRMLocalityID != item.value) : input.CRMWhatsappMarketingCampaignCRMLocalityID.push(item.value); input.allCRMWhatsappMarketingCampaignCRMLocalityIDSelected = input.CRMWhatsappMarketingCampaignCRMLocalityID.length == systemInformationData.CRMLocalities.length;"
                                  :title="null" 
                                  :subtitle="null"
                                  :active="input.CRMWhatsappMarketingCampaignCRMLocalityID.includes(item.value)"
                                  class="hoverableVListItem"
                                >
                                  <template v-slot:prepend>
                                    <v-checkbox-btn 
                                      :model-value="input.CRMWhatsappMarketingCampaignCRMLocalityID.includes(item.value)"
                                      density="compact"
                                      readonly
                                      hide-details
                                      class="hoverableVIcon"
                                      style="margin-right: 10px;"
                                    ></v-checkbox-btn>
                                  </template>
                                  <v-chip 
                                    :color="systemInformationData.CRMLocalities.find(CRMLocality => CRMLocality.CRMLocalityID == item.value) ? systemInformationData.CRMLocalities.find(CRMLocality => CRMLocality.CRMLocalityID == item.value).CRMLocalityColor || 'primary' : 'primary'"
                                    density="dense"
                                    variant="flat"
                                    elevation="2"
                                    label
                                    style="margin-top: 5px; margin-bottom: 5px;"
                                  >
                                    <p>{{ systemInformationData.CRMLocalities.find(CRMLocality => CRMLocality.CRMLocalityID == item.value) ? systemInformationData.CRMLocalities.find(CRMLocality => CRMLocality.CRMLocalityID == item.value).CRMLocalityName : 'No registrada' }}</p>
                                  </v-chip>
                                </v-list-item>
                              </v-list>
                            </template>
                          </v-autocomplete>
                          <v-textarea
                            v-model="input.CRMWhatsappMarketingCampaignCRMWhatsappTextMessageContent"
                            :loading="loader.startup || loader.selectCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignsView"
                            :disabled="loader.startup || loader.selectCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignsView"
                            label="Filtrar por contenido del mensaje de texto"
                            prepend-inner-icon="mdi-message-text"
                            clear-icon="mdi-backspace"
                            variant="outlined"
                            density="compact"
                            autocomplete="off"
                            rows="3"
                            max-rows="3"
                            no-resize
                            clearable
                            hide-details
                          ></v-textarea>
                        </div>
                        <v-card color="indigo" elevation="0" rounded="0" style="width: 100%; height: 2px; flex-shrink: 0;"></v-card>
                        <v-card color="primary" rounded="0" elevation="0" style="padding: 10px;">
                          <v-btn
                            @click="selectCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignsView(true)"
                            :disabled="loader.startup || loader.selectCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignsView"
                            color="indigo"
                            density="compact"
                            class="hoverableVButton"
                            block
                          >
                            <v-icon size="small" start>mdi-magnify</v-icon>
                            <p style="font-size: small;">BUSCAR</p>
                          </v-btn>
                          <v-btn
                            @click="input.CRMWhatsappMarketingCampaignName = null; input.CRMWhatsappMarketingCampaignDescription = null; input.CRMWhatsappMarketingCampaignType.length = 0; input.allCRMWhatsappMarketingCampaignTypeSelected = false; input.CRMWhatsappMarketingCampaignStatus.length = 0; input.allCRMWhatsappMarketingCampaignStatusSelected = false; input.CRMWhatsappMarketingCampaignCRMLocalityID.length = 0; input.allCRMWhatsappMarketingCampaignCRMLocalityIDSelected = false; input.CRMWhatsappMarketingCampaignCRMWhatsappTextMessageContent = null; selectCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignsView(true)"
                            :disabled="loader.startup || loader.selectCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignsView"
                            color="secondary"
                            density="compact"
                            class="hoverableVButton"
                            style="margin-top: 10px;"
                            block
                          >
                            <v-icon size="small" start>mdi-backspace</v-icon>
                            <p style="font-size: small;">LIMPIAR</p>
                          </v-btn>
                        </v-card>
                      </v-card>
                    </v-menu>
                  </v-list>
                </v-menu>
              </div>
              <div class="paginationContainer">
                <v-pagination
                  v-model="navigation.CRMWhatsappMarketingCampaignPage"
                  @update:model-value="selectCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignsView(false)"
                  :length="Math.ceil(computed_CRMWhatsappMarketingCampaignCount / navigation.CRMWhatsappMarketingCampaignLimit)"
                  :disabled="loader.selectCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignsView"
                  :total-visible="3"
                  density="compact"
                  size="small"
                ></v-pagination>
                <p style="font-size: x-small;">{{ (computed_CRMWhatsappMarketingCampaignCount == 0) ? '0 de 0 campañas' : `${(navigation.CRMWhatsappMarketingCampaignPage - 1) * navigation.CRMWhatsappMarketingCampaignLimit + 1} - ${Math.min(navigation.CRMWhatsappMarketingCampaignPage * navigation.CRMWhatsappMarketingCampaignLimit, computed_CRMWhatsappMarketingCampaignCount)} de ${computed_CRMWhatsappMarketingCampaignCount} campañas`}}</p>
              </div>
            </v-card>
          </template>
        </v-card>
        <v-card elevation="0" rounded="0" color="border" class="contentContainer">
          <template v-if="loader.selectCRMWhatsappMarketingCampaignDetailFromCRMWhatsappMarketingCampaignsView">
            <AppLoaderScreen
              :appLogoSize="'x-small'"
              :loadingText="'Cargando campaña de marketing'"
              :dotsToAnimate="3"
            ></AppLoaderScreen>
          </template>
          <template v-else>
            <template v-if="display.currentCRMWhatsappMarketingCampaign != null">
              <template v-if="$vuetify.display.width < 1200">
                <v-card elevation="0" rounded="0" color="indigo" style="width: 100%; height: 2px; flex-shrink: 0;"></v-card>
                <v-card elevation="0" rounded="0" color="border" style="width: 100%; height: 20px; flex-shrink: 0;"></v-card>
                <v-card elevation="0" rounded="0" color="indigo" style="width: 100%; height: 2px; flex-shrink: 0;"></v-card>
              </template>
              <v-card elevation="0" rounded="0" color="primary" style="width: 100%; height: 60px; padding: 15px; display: flex; align-items: center; flex-shrink: 0;">
                <h4>{{ display.currentCRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignName }}</h4>
                <div style="margin-left: auto; display: flex; gap: 15px;">
                  <v-btn
                    @click="$root.dialogComponent.openCRMWhatsappMarketingCampaignDialog('update', (() => selectCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignsView(true)), display.currentCRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignID)"
                    color="warning"
                    class="hoverableVButton"
                    density="compact"
                  >
                    <v-icon size="small" start>mdi-pencil</v-icon>
                    <p style="font-size: small;">ACTUALIZAR</p>
                  </v-btn>
                  <v-btn
                    @click="$root.dialogComponent.openCRMWhatsappMarketingCampaignDialog('delete', (() => selectCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignsView(true)), display.currentCRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignID)"
                    color="error"
                    class="hoverableVButton"
                    density="compact"
                  >
                    <v-icon size="small" start>mdi-delete</v-icon>
                    <p style="font-size: small;">ELIMINAR</p>
                  </v-btn>
                </div>
              </v-card>
              <v-card elevation="0" rounded="0" color="indigo" style="width: 100%; height: 2px; flex-shrink: 0;"></v-card>
              <div class="contentContentContainer">
                <template v-if="navigation.CRMWhatsappMarketingCampaignTab == 'Información'">
                  <v-card elevation="2" style="border: 2px solid #343A40; margin: 15px;">
                    <v-card color="primary" elevation="0" rounded="0" style="padding: 10px;">
                      <div style="display: flex; align-items: center;">
                        <v-icon color="indigo" style="margin-right: 10px;">mdi-information</v-icon>
                        <p><strong>Información</strong></p>
                      </div>
                    </v-card>
                    <v-card elevation="0" rounded="0" color="indigo" style="height: 2px;"></v-card>
                    <div class="twoColumnContainer" style="gap: 10px;">
                      <div style="display: flex; flex-direction: column; gap: 10px;">
                        <div style="display: flex; gap: 5px;">
                          <v-icon color="indigo">mdi-barcode</v-icon>
                          <p><strong>ID:</strong> {{ display.currentCRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignID }}</p>
                        </div>
                        <div style="display: flex; gap: 5px;">
                          <v-icon color="indigo">mdi-alphabetical-variant</v-icon>
                          <p><strong>Nombre:</strong> {{ display.currentCRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignName }}</p>
                        </div>
                        <div style="display: flex; gap: 5px;">
                          <v-icon color="indigo">mdi-text-box</v-icon>
                          <template v-if="display.currentCRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignDescription == null">
                            <p><strong>Descripción:</strong> <span style="font-size: x-small; color: #9e9e9e;">Sin descripción</span></p>
                          </template>
                          <template v-else>
                            <p style="max-height: 150px; overflow-y: auto; scrollbar-width: thin; scrollbar-color: #3F51B5 transparent;"><strong>Descripción:</strong> {{ display.currentCRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignDescription }}</p>
                          </template>
                        </div>
                        <div style="display: flex; gap: 5px;">
                          <v-icon color="indigo">mdi-source-branch</v-icon>
                          <p><strong>Tipo:</strong></p>
                          <v-chip
                            :color="{'Difusión': 'teal', 'Promoción': 'info', 'Código de descuento': 'warning', 'Otro': 'blue-secondary'}[display.currentCRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignType]"
                            variant="flat"
                            elevation="2"
                            density="compact"
                            label
                            style="margin-left: 5px;"
                          >
                            <p>{{ display.currentCRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignType }}</p>
                          </v-chip>
                        </div>
                        <div style="display: flex; gap: 5px; align-items: center;">
                          <v-icon color="indigo">mdi-store</v-icon>
                          <template v-if="display.currentCRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignCRMLocalityID == null">
                            <p><strong>Localidad:</strong> <span style="font-size: x-small; color: #9e9e9e;">No registrada</span></p>
                          </template>
                          <template v-else>
                            <p><strong>Localidad:</strong></p>
                            <v-chip
                              :color="display.currentCRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignCRMLocalityColor || 'primary'"
                              variant="flat"
                              elevation="2"
                              density="compact"
                              label
                              style="margin-left: 5px;"
                            >
                              <p>{{ display.currentCRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignCRMLocalityName || 'No registrada' }}</p>
                            </v-chip>
                          </template>
                        </div>
                      </div>
                      <div style="display: flex; flex-direction: column; gap: 10px;">
                        <div style="display: flex; gap: 5px;">
                          <v-icon color="indigo">mdi-clock</v-icon>
                          <p><strong>Estado:</strong></p>
                          <v-chip
                            :color="{'Activa': 'success', 'Inactiva': 'secondary', 'Finalizada': 'error'}[display.currentCRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignStatus]"
                            variant="flat"
                            elevation="2"
                            density="compact"
                            label
                          >
                            <p>{{ display.currentCRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignStatus }}</p>
                          </v-chip>
                        </div>
                        <div style="display: flex; gap: 5px;">
                          <v-icon color="indigo">mdi-message-text</v-icon>
                          <p style="max-height: 150px; overflow-y: auto; scrollbar-width: thin; scrollbar-color: #3F51B5 transparent;"><strong>Contenido del mensaje de texto:</strong> {{ display.currentCRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignCRMWhatsappTextMessageContent }}</p>
                        </div>
                        <div style="display: flex; gap: 5px; align-items: center;">
                          <v-icon color="indigo">mdi-account-plus</v-icon>
                          <p><strong>Creación:</strong></p>
                          <v-chip
                            :color="display.currentCRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignCreationCRMAgentColor || 'primary'"
                            variant="flat"
                            elevation="2"
                            label
                            style="margin-left: 5px;"
                          >
                            <div style="display: flex; align-items: center;">
                              <img
                                :src="display.currentCRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignCreationCRMAgentProfilePictureURL == null ? require('@/assets/images/CRMAgentProfilePicturePlaceholder.png') : display.currentCRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignCreationCRMAgentProfilePictureURL"
                                :draggable="false"
                                style="width: 25px; height: 25px; border-radius: 50%; object-fit: cover; margin-right: 10px;"
                              >
                              <div style="display: flex; flex-direction: column;">
                                <p>{{ display.currentCRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignCreationCRMAgentName == null ? 'No registrado' : display.currentCRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignCreationCRMAgentName }}</p>
                                <div style="display: flex; align-items: center; gap: 5px;">
                                  <v-icon size="x-small">mdi-clock</v-icon>
                                  <p style="font-size: x-small;">{{ $displayFunctions.default.fromDatetimeToHHMMSSDDMMYYYY(display.currentCRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignCreationDatetime) }}</p>
                                </div>
                              </div>
                            </div>
                          </v-chip>
                        </div>
                        <div style="display: flex; gap: 5px; align-items: center;">
                          <v-icon color="indigo">mdi-account-edit</v-icon>
                          <template v-if="display.currentCRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignUpdateCRMAgentID == null">
                            <p><strong>Actualización:</strong> <span style="font-size: x-small; color: #9e9e9e;">No actualizado</span></p>
                          </template>
                          <template v-else>
                            <p><strong>Actualización:</strong></p>
                            <v-chip
                              :color="display.currentCRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignUpdateCRMAgentColor || 'primary'"
                              variant="flat"
                              elevation="2"
                              label
                              style="margin-left: 5px;"
                            >
                              <div style="display: flex; align-items: center;">
                                <img
                                  :src="display.currentCRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignUpdateCRMAgentProfilePictureURL == null ? require('@/assets/images/CRMAgentProfilePicturePlaceholder.png') : display.currentCRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignUpdateCRMAgentProfilePictureURL"
                                  :draggable="false"
                                  style="width: 25px; height: 25px; border-radius: 50%; object-fit: cover; margin-right: 10px;"
                                >
                                <div style="display: flex; flex-direction: column;">
                                  <p>{{ display.currentCRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignUpdateCRMAgentName == null ? 'No registrado' : display.currentCRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignUpdateCRMAgentName }}</p>
                                  <div style="display: flex; align-items: center; gap: 5px;">
                                    <v-icon size="x-small">mdi-clock</v-icon>
                                    <p style="font-size: x-small;">{{ $displayFunctions.default.fromDatetimeToHHMMSSDDMMYYYY(display.currentCRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignUpdateDatetime) }}</p>
                                  </div>
                                </div>
                              </div>
                            </v-chip>
                          </template>
                        </div>
                      </div>
                    </div>
                  </v-card>
                  <v-card elevation="2" style="border: 2px solid #343A40; margin: 15px;">
                    <v-card color="primary" elevation="0" rounded="0" style="padding: 10px;">
                      <div style="display: flex; align-items: center;">
                        <v-icon color="indigo" style="margin-right: 10px;">mdi-chart-pie</v-icon>
                        <p><strong>Estadísticas</strong></p>
                      </div>
                    </v-card>
                    <v-card elevation="0" rounded="0" color="indigo" style="height: 2px;"></v-card>
                    <div class="twoColumnContainer">
                        <div style="display: flex; flex-direction: column; gap: 10px; justify-content: center;">
                          <div style="display: flex; align-items: center; gap: 5px;">
                            <v-icon color="indigo">mdi-cash-minus</v-icon>
                            <p><strong>Costo por mensaje: </strong>{{ $displayFunctions.default.parseAmountToDisplay(0.01) }} <span style="color: #3F51B5;"><strong>USD</strong></span></p>
                          </div>
                          <div style="display: flex; align-items: center; gap: 5px;">
                            <v-icon color="indigo">mdi-numeric</v-icon>
                            <p><strong>Cantidad de mensajes generados: </strong>{{ display.currentCRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignMessageCount }}</p>
                          </div>
                          <div style="display: flex; align-items: center; gap: 5px;">
                            <v-icon color="indigo">mdi-cash-minus</v-icon>
                            <p><strong>Costo total: </strong>{{ $displayFunctions.default.parseAmountToDisplay(0.01 * display.currentCRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignMessageCount) }} <span style="color: #3F51B5;"><strong>USD</strong></span></p>
                          </div>
                        </div>
                        <template v-if="display.currentCRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignMessageCount > 0">                    
                          <div style="display: flex; gap: 10px; justify-content: center;">
                            <div style="display: flex;">
                              <v-pie
                                :items="[{'title': 'Mensajes no enviados', 'value': display.currentCRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignMessageCount - display.currentCRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignMessageSentCount, 'color': '#9e9e9e'}, {'title': 'Mensajes enviados', 'value': display.currentCRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignMessageSentCount, 'color': '#de8d00'}]"
                                :palette="['#9e9e9e', '#99C24D']"
                                :inner-cut="65"
                                size="150"
                                animation
                                tooltip
                                hide-slice
                                style="cursor: pointer;"
                              >
                                <template v-slot:center>
                                  <p style="font-size: x-small; color: #9e9e9e"><strong>ENVIADOS</strong></p>
                                </template>
                                <template v-slot:tooltip="{ item, total }">
                                  <v-chip
                                    :color="item.color"
                                    variant="flat"
                                    density="compact"
                                    label
                                  >
                                    <p style="font-size: small;"><strong>{{ item.title }}</strong></p>
                                  </v-chip>
                                  <p style="font-size: small; margin-top: 10px;"><strong>Cantidad: </strong>{{ $displayFunctions.default.parseAmountToDisplayWithoutDecimals(item.value) }}</p>
                                  <p style="font-size: small;"><strong>Porcentaje: </strong>{{ $displayFunctions.default.parseAmountToDisplay(item.value / total * 100) }} %</p>
                                </template>
                              </v-pie>
                              <v-tooltip location="top">
                                <template v-slot:activator="{ props }">
                                  <v-icon
                                    v-bind="props"
                                    size="x-small"
                                    color="secondary"
                                    class="hoverableVIcon"
                                  >
                                    mdi-information
                                  </v-icon>
                                </template>
                                <span style="max-width: 400px; display: block;">Cantidad de mensajes enviados a los contactos que forman parte de esta campaña de marketing</span>
                              </v-tooltip>
                            </div>
                            <div style="display: flex;">
                              <v-pie
                                :items="[{'title': 'Mensajes no recibidos', 'value': display.currentCRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignMessageCount - display.currentCRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignMessageDeliveredCount, 'color': '#9e9e9e'}, {'title': 'Mensajes recibidos', 'value': display.currentCRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignMessageDeliveredCount, 'color': '#99C24D'}]"
                                :palette="['#9e9e9e', '#de8d00']"
                                :inner-cut="65"
                                size="150"
                                animation
                                tooltip
                                hide-slice
                                style="cursor: pointer;"
                              >
                                <template v-slot:center>
                                  <p style="font-size: x-small; color: #9e9e9e"><strong>RECIBIDOS</strong></p>
                                </template>
                                <template v-slot:tooltip="{ item, total }">
                                  <v-chip
                                    :color="item.color"
                                    variant="flat"
                                    density="compact"
                                    label
                                  >
                                    <p style="font-size: small;"><strong>{{ item.title }}</strong></p>
                                  </v-chip>
                                  <p style="font-size: small; margin-top: 10px;"><strong>Cantidad: </strong>{{ $displayFunctions.default.parseAmountToDisplayWithoutDecimals(item.value) }}</p>
                                  <p style="font-size: small;"><strong>Porcentaje: </strong>{{ $displayFunctions.default.parseAmountToDisplay(item.value / total * 100) }} %</p>
                                </template>
                              </v-pie>
                              <v-tooltip location="top">
                                <template v-slot:activator="{ props }">
                                  <v-icon
                                    v-bind="props"
                                    size="x-small"
                                    color="secondary"
                                    class="hoverableVIcon"
                                  >
                                    mdi-information
                                  </v-icon>
                                </template>
                                <span style="max-width: 400px; display: block;">Cantidad de mensajes recibidos por los contactos que forman parte de esta campaña de marketing</span>
                              </v-tooltip>
                            </div>
                            <div style="display: flex;">
                              <v-pie
                                :items="[{'title': 'Mensajes no leídos', 'value': display.currentCRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignMessageCount - display.currentCRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignMessageReadCount, 'color': '#9e9e9e'}, {'title': 'Mensajes leídos', 'value': display.currentCRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignMessageReadCount, 'color': '#00aede'}]"
                                :palette="['#9e9e9e', '#00aede']"
                                :inner-cut="65"
                                size="150"
                                animation
                                tooltip
                                hide-slice
                                style="cursor: pointer;"
                              >
                                <template v-slot:center>
                                  <p style="font-size: x-small; color: #9e9e9e"><strong>LEÍDOS</strong></p>
                                </template>
                                <template v-slot:tooltip="{ item, total }">
                                  <v-chip
                                    :color="item.color"
                                    variant="flat"
                                    density="compact"
                                    label
                                  >
                                    <p style="font-size: small;"><strong>{{ item.title }}</strong></p>
                                  </v-chip>
                                  <p style="font-size: small; margin-top: 10px;"><strong>Cantidad: </strong>{{ $displayFunctions.default.parseAmountToDisplayWithoutDecimals(item.value) }}</p>
                                  <p style="font-size: small;"><strong>Porcentaje: </strong>{{ $displayFunctions.default.parseAmountToDisplay(item.value / total * 100) }} %</p>
                                </template>
                              </v-pie>
                              <v-tooltip location="top">
                                <template v-slot:activator="{ props }">
                                  <v-icon
                                    v-bind="props"
                                    size="x-small"
                                    color="secondary"
                                    class="hoverableVIcon"
                                  >
                                    mdi-information
                                  </v-icon>
                                </template>
                                <span style="max-width: 400px; display: block;">Cantidad de mensajes leídos por los contactos que forman parte de esta campaña de marketing. Esta estadística puede diferir de la realidad ya que depende de la configuración de privacidad de los contactos</span>
                              </v-tooltip>
                            </div>
                          </div>
                        </template>
                        <template v-else>
                          <div></div>
                        </template>
                      <div style="display: flex; flex-direction: column; gap: 10px; justify-content: center;">
                        <div style="display: flex; align-items: center; gap: 5px;">
                          <v-icon color="indigo">mdi-invoice-text</v-icon>
                          <p><strong>Cantidad de órdenes generadas: </strong>{{ display.currentCRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignInvoiceCount }}</p>
                        </div>
                        <div style="display: flex; align-items: center; gap: 5px;">
                          <v-icon color="indigo">mdi-cash-sync</v-icon>
                          <p><strong>Ticket promedio: </strong>{{ display.currentCRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignInvoiceCount > 0 ? $displayFunctions.default.parseAmountToDisplay(display.currentCRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignInvoiceAmount / display.currentCRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignInvoiceCount) : '0.00' }} <span style="color: #3F51B5;"><strong>CRC</strong></span></p>
                        </div>
                        <div style="display: flex; align-items: center; gap: 5px;">
                          <v-icon color="indigo">mdi-cash-plus</v-icon>
                          <p><strong>Monto facturado: </strong>{{ $displayFunctions.default.parseAmountToDisplay(display.currentCRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignInvoiceAmount) }} <span style="color: #3F51B5;"><strong>CRC</strong></span></p>
                        </div>
                        <div style="display: flex; align-items: center; gap: 5px;">
                          <v-icon color="indigo">mdi-chart-line</v-icon>
                          <p><strong>ROI: </strong>{{ display.currentCRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignMessageCount > 0 ? $displayFunctions.default.parseAmountToDisplay((display.currentCRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignInvoiceAmount - (0.01 * display.currentCRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignMessageCount)) / (0.01 * display.currentCRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignMessageCount) * 100) : '0.00' }} %</p>
                          <v-tooltip location="top">
                            <template v-slot:activator="{ props }">
                              <v-icon
                                v-bind="props"
                                size="x-small"
                                color="secondary"
                                class="hoverableVIcon"
                              >
                                mdi-information
                              </v-icon>
                            </template>
                            <span style="max-width: 400px; display: block;">El ROI (return of investment) es el porcentaje de rentabilidad de la inversión en la campaña de marketing. Se calcula en base al monto facturado y el costo total de la campaña de marketing</span>
                          </v-tooltip>
                        </div>
                      </div>
                      <template v-if="display.currentCRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignMessageCount > 0">
                        <div style="display: flex; align-items: center; justify-content: center;">
                          <div style="display: flex;">
                            <v-pie
                              :items="[{'title': 'No vendido', 'value': display.currentCRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignMessageCount - display.currentCRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignInvoiceCount, 'color': '#961414'}, {'title': 'Vendido', 'value': display.currentCRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignInvoiceCount, 'color': '#005c18'}]"
                              :palette="['#961414', '#005c18']"
                              :inner-cut="65"
                              size="250"
                              animation
                              tooltip
                              hide-slice
                              style="cursor: pointer;"
                            >
                              <template v-slot:center>
                                <p style="font-size: small; color: #9e9e9e"><strong>CONVERSIÓN</strong></p>
                              </template>
                              <template v-slot:tooltip="{ item, total }">
                                <v-chip
                                  :color="item.color"
                                  variant="flat"
                                  density="compact"
                                  label
                                >
                                  <p style="font-size: small;"><strong>{{ item.title }}</strong></p>
                                </v-chip>
                                <p style="font-size: small; margin-top: 10px;"><strong>Cantidad: </strong>{{ $displayFunctions.default.parseAmountToDisplayWithoutDecimals(item.value) }}</p>
                                <p style="font-size: small;"><strong>Porcentaje: </strong>{{ $displayFunctions.default.parseAmountToDisplay(item.value / total * 100) }} %</p>
                              </template>
                            </v-pie>
                            <v-tooltip location="top">
                              <template v-slot:activator="{ props }">
                                <v-icon
                                  v-bind="props"
                                  size="x-small"
                                  color="secondary"
                                  class="hoverableVIcon"
                                >
                                  mdi-information
                                </v-icon>
                              </template>
                              <span style="max-width: 400px; display: block;">Porcentaje de contactos que han comprado en los siete días próximos al envío del mensaje de la campaña de marketing</span>
                            </v-tooltip>
                          </div>
                        </div>
                      </template>
                      <template v-else>
                        <div></div>
                      </template>
                    </div>
                  </v-card>
                </template>
                <template v-if="['Enviar', 'Enviados'].includes(navigation.CRMWhatsappMarketingCampaignTab)">
                  <template v-if="loader.selectCRMWhatsappContactToSendFromCRMWhatsappMarketingCampaignsView">
                    <AppLoaderScreen
                      :appLogoSize="'x-small'"
                      :loadingText="navigation.CRMWhatsappMarketingCampaignTab == 'Enviar' ? 'Cargando lista de contactos para enviar la campaña de marketing' : 'Cargando lista de contactos a los que se ha enviado la campaña de marketing'"
                      :dotsToAnimate="3"
                    ></AppLoaderScreen>
                  </template>
                  <template v-else>
                    <template v-if="computed_CRMWhatsappContactToSendCount > 0">
                      <v-data-table
                        :headers="computed_CRMWhatsappContactToSendHeaders"
                        :items="computed_CRMWhatsappContactToSend"
                        :hover="computed_CRMWhatsappContactToSend.length > 1"
                        :items-per-page="-1"
                        fixed-header
                        style="flex: 1; min-height: 100%; height: 100%; overflow-y: auto; scrollbar-width: thin; scrollbar-color: #3F51B5 transparent;"
                      >
                        <template v-slot:headers="{ columns }">
                          <tr>
                            <template
                              v-for="column in columns"
                              :key="column.value"
                            >
                              <th>
                                <v-card
                                  :style="computed_CRMWhatsappContactToSendHeaders.find(header => header.value == column.value).value == 'select' ? null : 'padding: 0px 25px;'"
                                  elevation="0"
                                  rounded="0"
                                  style="display: flex; align-items: center; white-space: nowrap; height: 58px; width: 100%;"
                                >
                                  <template v-if="computed_CRMWhatsappContactToSendHeaders.find(header => header.value == column.value).value == 'select'">
                                    <template v-if="computed_CRMWhatsappContactToSendCount > 1">
                                      <v-checkbox
                                        :model-value="computed_CRMWhatsappContactToSend.every(currentComputedCRMWhatsappContactToSend => input.CRMWhatsappContactToSend.find(currentCRMWhatsappContactToSend => currentCRMWhatsappContactToSend.CRMWhatsappContactID == currentComputedCRMWhatsappContactToSend.CRMWhatsappContactID) != null)"
                                        @click="computed_CRMWhatsappContactToSend.every(currentComputedCRMWhatsappContactToSend => input.CRMWhatsappContactToSend.find(currentCRMWhatsappContactToSend => currentCRMWhatsappContactToSend.CRMWhatsappContactID == currentComputedCRMWhatsappContactToSend.CRMWhatsappContactID) != null) ? input.CRMWhatsappContactToSend.length = 0 : computed_CRMWhatsappContactToSend.forEach(currentComputedCRMWhatsappContactToSend => (input.CRMWhatsappContactToSend.find(currentCRMWhatsappContactToSend => currentCRMWhatsappContactToSend.CRMWhatsappContactID == currentComputedCRMWhatsappContactToSend.CRMWhatsappContactID) != null) ? null : input.CRMWhatsappContactToSend.push(currentComputedCRMWhatsappContactToSend))"
                                        :disabled="loader.selectCRMWhatsappContactToSendFromCRMWhatsappMarketingCampaignsViewPagination"
                                        color="indigo"
                                        density="compact"
                                        hide-details
                                        class="hoverableVIcon"
                                      ></v-checkbox>
                                    </template>
                                  </template>
                                  <template v-else>
                                    <template v-if="computed_CRMWhatsappContactToSendHeaders.find(header => header.value == column.value).index > 1">
                                      <v-icon 
                                        @click="updateTableHeaderIndex('CRMWhatsappContactToSend', column.value, -1)"
                                        color="tertiary"
                                        size="x-small"
                                        class="hoverableVIcon"
                                        style="margin-right: 10px"
                                      >
                                        mdi-arrow-left-bold
                                      </v-icon>
                                    </template>
                                    <v-icon color="indigo" style="margin-right: 5px;">{{ computed_CRMWhatsappContactToSendHeaders.find(header => header.value == column.value).icon }}</v-icon>
                                    <template v-if="computed_CRMWhatsappContactToSendHeaders.find(header => header.value == column.value).visible">
                                      <p style="margin-right: 5px; display: flex; align-items: center;"><strong>{{ computed_CRMWhatsappContactToSendHeaders.find(header => header.value == column.value).title }}</strong></p>
                                    </template>
                                    <v-icon 
                                      @click="computed_CRMWhatsappContactToSendHeaders.find(header => header.value == column.value).visible = !computed_CRMWhatsappContactToSendHeaders.find(header => header.value == column.value).visible; updateTableVisibility('CRMWhatsappContactToSend')"
                                      color="tertiary"
                                      size="x-small"
                                      class="hoverableVIcon"
                                    >
                                      mdi-{{ computed_CRMWhatsappContactToSendHeaders.find(header => header.value == column.value).visible ? 'eye' : 'eye-off' }}
                                    </v-icon>
                                    <template v-if="computed_CRMWhatsappContactToSendHeaders.find(header => header.value == column.value).index < computed_CRMWhatsappContactToSendHeaders.length - 1">
                                      <v-icon
                                        @click="updateTableHeaderIndex('CRMWhatsappContactToSend', column.value, 1)"
                                        color="tertiary"
                                        size="x-small"
                                        class="hoverableVIcon"
                                        style="margin-left: 10px"
                                      >
                                        mdi-arrow-right-bold
                                      </v-icon>
                                    </template>
                                  </template>
                                </v-card>
                                <v-card color="secondary-lighten-2" elevation="0" rounded="0" style="height: 1px;"></v-card>
                              </th>
                            </template>
                          </tr>
                        </template>
                        <template v-slot:item="row">
                          <tr
                            :class="getTableRowClass('CRMWhatsappContactToSend', row.item)" 
                            :style="loader.selectCRMWhatsappContactToSendFromCRMWhatsappMarketingCampaignsView ? 'pointer-events: none;' : null"
                          >
                            <template
                              v-for="header in computed_CRMWhatsappContactToSendHeaders"
                              :key="header.value"
                            >
                              <td @contextmenu.prevent="input.CRMWhatsappContactToSend.find(currentCRMWhatsappContactToSend => currentCRMWhatsappContactToSend.CRMWhatsappContactID == row.item.CRMWhatsappContactID) == null ? input.CRMWhatsappContactToSend.push(row.item) : input.CRMWhatsappContactToSend = input.CRMWhatsappContactToSend.filter(CRMWhatsappContactToSend => CRMWhatsappContactToSend.CRMWhatsappContactID != row.item.CRMWhatsappContactID)">
                                <template v-if="header.value == 'select' && computed_CRMWhatsappContactToSendHeaders.find(currentCRMWhatsappContactToSendHeader => currentCRMWhatsappContactToSendHeader.value == header.value).visible">
                                  <v-checkbox-btn
                                    :model-value="input.CRMWhatsappContactToSend.find(currentCRMWhatsappContactToSend => currentCRMWhatsappContactToSend.CRMWhatsappContactID == row.item.CRMWhatsappContactID) != null"
                                    @click="input.CRMWhatsappContactToSend.find(currentCRMWhatsappContactToSend => currentCRMWhatsappContactToSend.CRMWhatsappContactID == row.item.CRMWhatsappContactID) == null ? input.CRMWhatsappContactToSend.push(row.item) : input.CRMWhatsappContactToSend = input.CRMWhatsappContactToSend.filter(CRMWhatsappContactToSend => CRMWhatsappContactToSend.CRMWhatsappContactID != row.item.CRMWhatsappContactID)"
                                    color="indigo"
                                    density="compact"
                                    hide-details
                                    class="hoverableVIcon"
                                  ></v-checkbox-btn>
                                </template>
                                <template v-else-if="header.value == 'CRMWhatsappContactID' && computed_CRMWhatsappContactToSendHeaders.find(currentCRMWhatsappContactToSendHeader => currentCRMWhatsappContactToSendHeader.value == header.value).visible">
                                  <v-hover>
                                    <template v-slot="{ isHovering, props: hoverProps }">
                                      <template v-if="isHovering == true && !systemInformationData.tooltipDisabled">
                                        <v-tooltip text="Copiar ID del contacto al portapapeles" location="top">
                                          <template v-slot:activator="{ props: tooltipProps }">
                                            <p 
                                              v-bind="tooltipProps"
                                              @click="$generalFunctions.default.copyToClipboardWithoutTitle(this, 'ID del contacto', 'o', row.item.CRMWhatsappContactID)"
                                              class="hoverableVIcon"
                                              style="color: #3F51B5;"
                                            >
                                              <strong>{{ row.item.CRMWhatsappContactID }}</strong>
                                            </p>
                                          </template>
                                        </v-tooltip>
                                      </template>
                                      <template v-else>
                                        <p
                                          v-bind="hoverProps"
                                          @click="$generalFunctions.default.copyToClipboardWithoutTitle(this, 'ID del contacto', 'o', row.item.CRMWhatsappContactID)"
                                          class="hoverableVIcon"
                                          style="color: #3F51B5;"
                                        >
                                          <strong>{{ row.item.CRMWhatsappContactID }}</strong>
                                        </p>
                                      </template>
                                    </template>
                                  </v-hover>
                                </template>
                                <template v-else-if="header.value == 'CRMWhatsappContact' && computed_CRMWhatsappContactToSendHeaders.find(currentCRMWhatsappContactToSendHeader => currentCRMWhatsappContactToSendHeader.value == header.value).visible">
                                  <p style="white-space: nowrap;">{{ $displayFunctions.default.parseCRMWhatsappContactNameToDisplay(row.item) }}</p>
                                  <p style="font-size: small; color: #9e9e9e; white-space: nowrap;">{{ $displayFunctions.default.fromPhoneNumberToCountryCodePhoneNumberCountryFlag(row.item.CRMWhatsappContactPhoneNumber, false) }}</p>
                                </template>
                                <template v-else-if="header.value == 'CRMWhatsappContactCRMLocality' && computed_CRMWhatsappContactToSendHeaders.find(currentCRMWhatsappContactToSendHeader => currentCRMWhatsappContactToSendHeader.value == header.value).visible">
                                  <template v-if="row.item.CRMWhatsappContactCRMLocalityID == null">
                                    <p style="font-size: x-small; color: #9e9e9e; white-space: nowrap;">No registrada</p>
                                  </template>
                                  <template v-else>
                                    <v-chip
                                      :color="systemInformationData.CRMLocalities.find(CRMLocality => CRMLocality.CRMLocalityID == row.item.CRMWhatsappContactCRMLocalityID) ? systemInformationData.CRMLocalities.find(CRMLocality => CRMLocality.CRMLocalityID == row.item.CRMWhatsappContactCRMLocalityID).CRMLocalityColor || 'primary' : 'primary'"
                                      variant="flat"
                                      elevation="2"
                                      density="compact"
                                      label
                                    >
                                      <p>{{ systemInformationData.CRMLocalities.find(CRMLocality => CRMLocality.CRMLocalityID == row.item.CRMWhatsappContactCRMLocalityID) ? systemInformationData.CRMLocalities.find(CRMLocality => CRMLocality.CRMLocalityID == row.item.CRMWhatsappContactCRMLocalityID).CRMLocalityName || 'No registrada' : 'No registrada' }}</p>
                                    </v-chip>
                                  </template>
                                </template>
                                <template v-else-if="header.value == 'CRMWhatsappMarketingCampaignMessage' && computed_CRMWhatsappContactToSendHeaders.find(currentCRMWhatsappContactToSendHeader => currentCRMWhatsappContactToSendHeader.value == header.value).visible">
                                  <div style="display: flex; gap: 5px; align-items: center;">
                                    <v-icon color="secondary">mdi-check</v-icon>
                                    <template v-if="row.item.lastCRMWhatsappMarketingCampaignMessageSendAPIDatetime == null || row.item.lastCRMWhatsappMarketingCampaignMessageSendAPIDatetimeTranscurredSeconds == null">
                                      <p><strong>Enviado a las:</strong> <span style="font-size: x-small; color: #9e9e9e;">No enviado</span></p>
                                    </template>
                                    <template v-else>
                                      <p style="white-space: nowrap;"><strong>Enviado a las:</strong> {{ $displayFunctions.default.fromDatetimeToHHMMSSDDMMYYYY(row.item.lastCRMWhatsappMarketingCampaignMessageSendAPIDatetime) }} <span style="font-size: x-small; color: #9e9e9e;">(hace {{ $displayFunctions.default.fromSecondsToDaysHHMMSS(row.item.lastCRMWhatsappMarketingCampaignMessageSendAPIDatetimeTranscurredSeconds) }})</span></p>
                                    </template>
                                  </div>
                                  <div style="display: flex; gap: 5px; align-items: center;">
                                    <v-icon color="secondary">mdi-check-all</v-icon>
                                    <template v-if="row.item.lastCRMWhatsappMarketingCampaignMessageDeliveredAPIDatetime == null || row.item.lastCRMWhatsappMarketingCampaignMessageDeliveredAPIDatetimeTranscurredSeconds == null">
                                      <p><strong>Recibido a las:</strong> <span style="font-size: x-small; color: #9e9e9e;">No recibido</span></p>
                                    </template>
                                    <template v-else>
                                      <p style="white-space: nowrap;"><strong>Recibido a las:</strong> {{ $displayFunctions.default.fromDatetimeToHHMMSSDDMMYYYY(row.item.lastCRMWhatsappMarketingCampaignMessageDeliveredAPIDatetime) }} <span style="font-size: x-small; color: #9e9e9e;">(hace {{ $displayFunctions.default.fromSecondsToDaysHHMMSS(row.item.lastCRMWhatsappMarketingCampaignMessageDeliveredAPIDatetimeTranscurredSeconds) }})</span></p>
                                    </template>
                                  </div>
                                  <div style="display: flex; gap: 5px; align-items: center;">
                                    <v-icon color="info">mdi-check-all</v-icon>
                                    <template v-if="row.item.lastCRMWhatsappMarketingCampaignMessageReadAPIDatetime == null || row.item.lastCRMWhatsappMarketingCampaignMessageReadAPIDatetimeTranscurredSeconds == null">
                                      <p><strong>Leído a las:</strong> <span style="font-size: x-small; color: #9e9e9e;">No leído</span></p>
                                    </template>
                                    <template v-else>
                                      <p style="white-space: nowrap;"><strong>Leído a las:</strong> {{ $displayFunctions.default.fromDatetimeToHHMMSSDDMMYYYY(row.item.lastCRMWhatsappMarketingCampaignMessageReadAPIDatetime) }} <span style="font-size: x-small; color: #9e9e9e;">(hace {{ $displayFunctions.default.fromSecondsToDaysHHMMSS(row.item.lastCRMWhatsappMarketingCampaignMessageReadAPIDatetimeTranscurredSeconds) }})</span></p>
                                    </template>
                                  </div>
                                </template>
                                <template v-else-if="header.value == 'lastCRMWhatsappConversationStartDatetime' && computed_CRMWhatsappContactToSendHeaders.find(currentCRMWhatsappContactToSendHeader => currentCRMWhatsappContactToSendHeader.value == header.value).visible">
                                  <template v-if="row.item.lastCRMWhatsappConversationStartDatetime == null || row.item.lastCRMWhatsappConversationStartDatetimeTranscurredSeconds == null">
                                    <p style="font-size: x-small; color: #9e9e9e; white-space: nowrap;">No registrado</p>
                                  </template>
                                  <template v-else>
                                    <p style="white-space: nowrap;">{{ $displayFunctions.default.fromDatetimeToHHMMSSDDMMYYYY(row.item.lastCRMWhatsappConversationStartDatetime) }}</p>
                                    <p style="font-size: x-small; color: #9e9e9e; white-space: nowrap;">(hace {{ $displayFunctions.default.fromSecondsToDaysHHMMSS(row.item.lastCRMWhatsappConversationStartDatetimeTranscurredSeconds) }})</p>
                                  </template>
                                </template>
                                <template v-else-if="header.value == 'lastCRMWhatsappInvoiceCreationDatetime' && computed_CRMWhatsappContactToSendHeaders.find(currentCRMWhatsappContactToSendHeader => currentCRMWhatsappContactToSendHeader.value == header.value).visible">
                                  <template v-if="row.item.lastCRMWhatsappInvoiceCreationDatetime == null || row.item.lastCRMWhatsappInvoiceCreationDatetimeTranscurredSeconds == null">
                                    <p style="font-size: x-small; color: #9e9e9e; white-space: nowrap;">No registrado</p>
                                  </template>
                                  <template v-else>
                                    <p style="white-space: nowrap;">{{ $displayFunctions.default.fromDatetimeToHHMMSSDDMMYYYY(row.item.lastCRMWhatsappInvoiceCreationDatetime) }}</p>
                                    <p style="font-size: x-small; color: #9e9e9e; white-space: nowrap;">(hace {{ $displayFunctions.default.fromSecondsToDaysHHMMSS(row.item.lastCRMWhatsappInvoiceCreationDatetimeTranscurredSeconds) }})</p>
                                  </template>
                                </template>
                                <template v-else-if="header.value == 'CRMWhatsappMarketingCampaignMessageCount' && computed_CRMWhatsappContactToSendHeaders.find(currentCRMWhatsappContactToSendHeader => currentCRMWhatsappContactToSendHeader.value == header.value).visible">
                                  <p style="white-space: nowrap;">{{ $displayFunctions.default.parseAmountToDisplayWithoutDecimals(row.item.CRMWhatsappMarketingCampaignMessageCount) }}</p>
                                </template>
                              </td>
                            </template>
                          </tr>
                        </template>
                        <template v-slot:bottom></template>
                      </v-data-table>
                    </template>
                    <template v-else>
                      <template v-if="loader.selectCRMWhatsappContactToSendFromCRMWhatsappMarketingCampaignsViewPagination">
                        <AppLoaderScreen
                          :appLogoSize="'x-small'"
                          :loadingText="navigation.CRMWhatsappMarketingCampaignTab == 'Enviar' ? 'Cargando lista de contactos para enviar la campaña de marketing' : 'Cargando lista de contactos a los que se ha enviado la campaña de marketing'"
                          :dotsToAnimate="3"
                        ></AppLoaderScreen>
                      </template>
                      <template v-else>
                        <div class="navigationNoContentContainer">
                          <v-icon color="indigo">mdi-information</v-icon>
                          <p style="margin-top: 5px; color: #9e9e9e;">{{ navigation.CRMWhatsappMarketingCampaignTab == 'Enviar' ? 'No se encontraron contactos para enviar la campaña de marketing' : 'No se encontraron contactos a los que se ha enviado la campaña de marketing' }}</p>
                          <template v-if="input.CRMWhatsappContactID.length > 0 || input.CRMWhatsappContactNameFirstLetter != null || input.CRMWhatsappContactCRMLocalityID.length > 0 || input.CRMWhatsappMarketingCampaignMessageCount != null">
                            <div style="display: flex; align-items: center; gap: 10px; margin-top: 10px;">
                              <p style="color: #9e9e9e;">Puedes limpiar los filtros de búsqueda con</p>
                              <v-btn
                                @click="input.CRMWhatsappContactID.length = 0; input.searchedCRMWhatsappContactID = null; input.allCRMWhatsappContactIDSelected = false; input.CRMWhatsappContactNameFirstLetter = null; input.CRMWhatsappContactCRMLocalityID.length = 0; input.allCRMWhatsappContactCRMLocalityIDSelected = false; input.lastCRMWhatsappConversationTime = null; input.lastCRMWhatsappInvoiceTime = null; input.CRMWhatsappMarketingCampaignMessageCount = null; selectCRMWhatsappContactToSendFromCRMWhatsappMarketingCampaignsView(false)"
                                color="secondary"
                                density="compact"
                                class="hoverableVButton"
                              >
                                <v-icon start>mdi-backspace</v-icon>
                                <p style="font-size: small;">LIMPIAR</p>
                              </v-btn>
                            </div>
                          </template>
                        </div>
                      </template>
                    </template>
                  </template>
                </template>
              </div>
              <v-card elevation="0" rounded="0" color="indigo" style="width: 100%; height: 2px; flex-shrink: 0;"></v-card>
              <v-card elevation="0" rounded="0" color="primary" style="width: 100%; flex-shrink: 0;">
                <template v-if="['Enviar', 'Enviados'].includes(navigation.CRMWhatsappMarketingCampaignTab) && loader.selectCRMWhatsappContactToSendFromCRMWhatsappMarketingCampaignsView == false">
                  <div class="footerContainer" style="padding: 10px;">
                    <div style="display: flex; align-items: center; gap: 10px;">
                      <v-menu
                        v-model="navigation.filterMenuIsVisible"
                        @contextmenu.prevent="null"
                        :close-on-content-click="false"
                        transition="scroll-y-transition"
                        scrim="black"
                        opacity="0.8"
                        style="user-select: none; cursor: default;"
                      >
                        <template v-slot:activator="{ props }">
                          <v-btn
                            v-bind="props"
                            color="secondary"
                            density="compact"
                            class="hoverableVButton"
                          >
                            <v-icon size="small" start>mdi-filter-variant</v-icon>
                            <p style="font-size: small;">FILTRAR</p>
                            <template v-if="input.CRMWhatsappContactID.length > 0 || input.CRMWhatsappContactNameFirstLetter != null || input.CRMWhatsappContactCRMLocalityID.length > 0 || input.CRMWhatsappMarketingCampaignMessageCount != null">
                              <v-icon color="error" end class="pulseElement">mdi-alert-circle</v-icon>
                            </template>
                          </v-btn>
                        </template>
                        <v-card style="width: 650px;">
                          <v-card color="primary" rounded="0" elevation="0" class="headerCard">
                            <div class="titleContainer">
                              <v-icon color="indigo" style="margin-right: 10px;">mdi-filter-variant</v-icon>
                              <p>FILTRAR CONTACTOS {{ navigation.CRMWhatsappMarketingCampaignTab == 'Enviar' ? 'A ENVIAR' : 'ENVIADOS' }}</p>
                            </div>
                            <div class="actionsContainer">
                              <v-btn 
                                @click="navigation.filterMenuIsVisible = false"
                                color="error"
                                density="compact"
                                class="hoverableVButton" 
                              >
                                <v-icon start>mdi-close-circle</v-icon>
                                <p style="font-size: small;">CERRAR</p>
                              </v-btn>
                            </div>
                          </v-card>
                          <v-card color="indigo" elevation="0" rounded="0" style="width: 100%; height: 2px; flex-shrink: 0;"></v-card>
                          <div style="padding: 15px;">
                            <v-autocomplete
                              ref="CRMWhatsappContactID"
                              v-model="input.CRMWhatsappContactID"
                              v-model:search="input.searchedCRMWhatsappContactID"
                              @update:model-value="input.allCRMWhatsappContactIDSelected = input.CRMWhatsappContactID.length == display.CRMWhatsappContact.length;"
                              :loading="loader.startup || loader.selectCRMWhatsappContactToSendFromCRMWhatsappMarketingCampaignsView || loader.selectCRMWhatsappContactToSendFromCRMWhatsappMarketingCampaignsViewPagination"
                              :disabled="loader.startup || loader.selectCRMWhatsappContactToSendFromCRMWhatsappMarketingCampaignsView || loader.selectCRMWhatsappContactToSendFromCRMWhatsappMarketingCampaignsViewPagination"
                              :items="computed_CRMWhatsappContact"
                              item-value="CRMWhatsappContactID"
                              item-title="CRMWhatsappContactName"
                              label="Filtrar por contacto"
                              prepend-inner-icon="mdi-account"
                              clear-icon="mdi-backspace"
                              variant="outlined"
                              density="compact"
                              autocomplete="off"
                              multiple
                              chips
                              closable-chips
                              clearable
                              hide-no-data
                              hide-details
                              style="margin-bottom: 15px;"
                            >
                              <template v-slot:chip="{ item, index }">
                                <template v-if="index < 3">
                                  <v-chip color="secondary" variant="flat" elevation="2" label>
                                    <p>{{ display.CRMWhatsappContact.find(currentCRMWhatsappContact => currentCRMWhatsappContact.CRMWhatsappContactID == item.value) ? display.CRMWhatsappContact.find(currentCRMWhatsappContact => currentCRMWhatsappContact.CRMWhatsappContactID == item.value).CRMWhatsappContactName || 'No registrado' : item.raw.CRMWhatsappContactName }}</p>
                                    <template v-slot:close>
                                      <v-icon 
                                        @click="input.CRMWhatsappContactID = input.CRMWhatsappContactID.filter(currentCRMWhatsappContactID => currentCRMWhatsappContactID != item.value); $generalFunctions.default.blurInput(this, 'CRMWhatsappContactID')"
                                        class="hoverableVIcon"
                                      >
                                        mdi-close-circle
                                      </v-icon>
                                    </template>
                                  </v-chip>
                                </template>
                                <template v-else-if="index == 3">
                                  <p style="color: #9e9e9e; font-size: small;">(+{{ input.CRMWhatsappContactID.length - 3 }} {{ input.CRMWhatsappContactID.length - 3 == 1 ? 'contacto' : 'contactos' }})</p>
                                </template>
                              </template>
                              <template v-slot:item="{ item, index }">
                                <template v-if="index == 0 && display.CRMWhatsappContact.length > 1">
                                  <v-list density="compact" style="overflow: hidden; padding: 0; margin: 0;">
                                    <v-list-item
                                      @click="input.allCRMWhatsappContactIDSelected = !input.allCRMWhatsappContactIDSelected; input.allCRMWhatsappContactIDSelected ? input.CRMWhatsappContactID = display.CRMWhatsappContact.map(currentCRMWhatsappContact => currentCRMWhatsappContact.CRMWhatsappContactID) : input.CRMWhatsappContactID.length = 0;"
                                      :title="null" 
                                      :subtitle="null"
                                      :active="input.allCRMWhatsappContactIDSelected"
                                      class="hoverableVListItem"
                                    >
                                      <template v-slot:prepend>
                                        <v-switch
                                          :model-value="input.allCRMWhatsappContactIDSelected"
                                          density="compact"
                                          color="indigo"
                                          readonly
                                          hide-details
                                          class="hoverableVIcon"
                                          style="margin-right: 20px;"
                                        ></v-switch>
                                        <template v-if="input.allCRMWhatsappContactIDSelected">
                                          <p>Deseleccionar todos los contactos</p>
                                        </template>
                                        <template v-else>
                                          <p>Seleccionar {{ (display.CRMWhatsappContact.length - input.CRMWhatsappContactID.length) == 1 ? 'el' : 'los' }}{{ (display.CRMWhatsappContact.length - input.CRMWhatsappContactID.length) > 1 ? ` ${(display.CRMWhatsappContact.length - input.CRMWhatsappContactID.length)}` : '' }} contacto{{ (display.CRMWhatsappContact.length - input.CRMWhatsappContactID.length) == 1 ? '' : 's' }} restante{{ (display.CRMWhatsappContact.length - input.CRMWhatsappContactID.length) == 1 ? '' : 's' }}</p>
                                        </template>
                                      </template>
                                    </v-list-item>
                                  </v-list>
                                </template>
                                <v-list density="compact" style="overflow: hidden; padding: 0; margin: 0;">
                                  <v-list-item
                                    @click="input.CRMWhatsappContactID.includes(item.raw.CRMWhatsappContactID) ? input.CRMWhatsappContactID = input.CRMWhatsappContactID.filter(CRMWhatsappContactID => CRMWhatsappContactID != item.raw.CRMWhatsappContactID) : input.CRMWhatsappContactID.push(item.raw.CRMWhatsappContactID); input.allCRMWhatsappContactIDSelected = input.CRMWhatsappContactID.length == display.CRMWhatsappContact.length;"
                                    :title="null" 
                                    :subtitle="null"
                                    :active="input.CRMWhatsappContactID.includes(item.raw.CRMWhatsappContactID)"
                                    class="hoverableVListItem"
                                  >
                                    <template v-slot:prepend>
                                      <v-checkbox-btn 
                                        :model-value="input.CRMWhatsappContactID.includes(item.raw.CRMWhatsappContactID)"
                                        density="compact"
                                        readonly
                                        hide-details
                                        class="hoverableVIcon"
                                        style="margin-right: 10px;"
                                      ></v-checkbox-btn>
                                    </template>
                                    <p>{{ item.raw.CRMWhatsappContactName }}</p>
                                    <p style="font-size: small; color: #9e9e9e;">{{ $displayFunctions.default.fromPhoneNumberToCountryCodePhoneNumberCountryFlag(item.raw.CRMWhatsappContactPhoneNumber, false) }}</p>
                                  </v-list-item>
                                </v-list>
                              </template>
                            </v-autocomplete>
                            <v-autocomplete
                              v-model="input.CRMWhatsappContactNameFirstLetter"
                              :items="display.CRMWhatsappContactNameFirstLetter"
                              :loading="loader.startup || loader.selectCRMWhatsappContactToSendFromCRMWhatsappMarketingCampaignsView || loader.selectCRMWhatsappContactToSendFromCRMWhatsappMarketingCampaignsViewPagination"
                              :disabled="loader.startup || loader.selectCRMWhatsappContactToSendFromCRMWhatsappMarketingCampaignsView || loader.selectCRMWhatsappContactToSendFromCRMWhatsappMarketingCampaignsViewPagination"
                              label="Filtrar por primer letra del nombre"
                              prepend-inner-icon="mdi-alphabetical-variant"
                              clear-icon="mdi-backspace"
                              variant="outlined"
                              density="compact"
                              autocomplete="off"
                              chips
                              closable-chips
                              clearable
                              hide-details
                              hide-no-data
                              style="margin-bottom: 15px;"
                            >
                              <template v-slot:chip="{ item }">
                                <v-chip color="secondary" elevation="2" variant="flat" label>
                                  <p>{{ item.raw.title }}</p>
                                  <template v-slot:close>
                                    <v-icon 
                                      @click="input.CRMWhatsappContactNameFirstLetter = null"
                                      class="hoverableVIcon"
                                    >
                                      mdi-close-circle
                                    </v-icon>
                                  </template>
                                </v-chip>
                              </template>
                              <template v-slot:item="{ item }">
                                <v-list density="compact" style="overflow: hidden; padding: 0; margin: 0;">
                                  <v-list-item 
                                    @click="input.CRMWhatsappContactNameFirstLetter = item.value"
                                    :title="null" 
                                    :subtitle="null"
                                    :active="input.CRMWhatsappContactNameFirstLetter == item.value"
                                    class="hoverableVListItem"
                                  >
                                    <template v-slot:prepend>
                                      <v-checkbox-btn 
                                        :model-value="input.CRMWhatsappContactNameFirstLetter == item.value"
                                        density="compact"
                                        readonly
                                        hide-details
                                        class="hoverableVIcon"
                                        style="margin-right: 10px;"
                                      ></v-checkbox-btn>
                                    </template>
                                    <p>{{ item.raw.title }}</p>
                                  </v-list-item>
                                </v-list>
                              </template>
                            </v-autocomplete>
                            <v-autocomplete
                              ref="CRMWhatsappContactCRMLocalityID"
                              v-model="input.CRMWhatsappContactCRMLocalityID"
                              @update:model-value="input.allCRMWhatsappContactCRMLocalityIDSelected = input.CRMWhatsappContactCRMLocalityID.length == systemInformationData.CRMLocalities.length;"
                              :items="systemInformationData.CRMLocalities"
                              :loading="loader.startup || loader.selectCRMWhatsappContactToSendFromCRMWhatsappMarketingCampaignsView || loader.selectCRMWhatsappContactToSendFromCRMWhatsappMarketingCampaignsViewPagination"
                              :disabled="loader.startup || loader.selectCRMWhatsappContactToSendFromCRMWhatsappMarketingCampaignsView || loader.selectCRMWhatsappContactToSendFromCRMWhatsappMarketingCampaignsViewPagination"
                              item-value="CRMLocalityID"
                              item-title="CRMLocalityName"
                              label="Filtrar por localidad"
                              prepend-inner-icon="mdi-store"
                              clear-icon="mdi-backspace"
                              variant="outlined"
                              density="compact"
                              autocomplete="off"
                              multiple
                              chips
                              closable-chips
                              clearable
                              hide-details
                              hide-no-data
                              style="margin-bottom: 15px;"
                            >
                              <template v-slot:chip="{ item, index }">
                                <template v-if="index < 3">
                                  <v-chip
                                    :color="systemInformationData.CRMLocalities.find(CRMLocality => CRMLocality.CRMLocalityID == item.value) ? systemInformationData.CRMLocalities.find(CRMLocality => CRMLocality.CRMLocalityID == item.value).CRMLocalityColor : 'primary'"
                                    variant="flat"
                                    elevation="2"
                                    label
                                  >
                                    <p>{{ systemInformationData.CRMLocalities.find(CRMLocality => CRMLocality.CRMLocalityID == item.value) ? systemInformationData.CRMLocalities.find(CRMLocality => CRMLocality.CRMLocalityID == item.value).CRMLocalityName : 'No registrada' }}</p>
                                    <template v-slot:close>
                                      <v-icon
                                        @click.stop="input.CRMWhatsappContactCRMLocalityID = input.CRMWhatsappContactCRMLocalityID.filter(CRMWhatsappContactCRMLocalityID => CRMWhatsappContactCRMLocalityID != item.value); updateURLSearchQuery(); $generalFunctions.default.blurInput(this, 'CRMWhatsappContactCRMLocalityID');"
                                        size="smaller"
                                      >
                                        mdi-close-circle
                                      </v-icon>
                                    </template>
                                  </v-chip>
                                </template>
                                <template v-else-if="index == 3">
                                  <p style="color: #9e9e9e; font-size: small;">(+{{ input.CRMWhatsappContactCRMLocalityID.length - 3 }} {{ input.CRMWhatsappContactCRMLocalityID.length - 3 == 1 ? 'localidad' : 'localidades' }})</p>
                                </template>
                              </template>
                              <template v-slot:item="{ item, index }">
                                <template v-if="index == 0 && systemInformationData.CRMLocalities.length > 1">
                                  <v-list density="compact" style="overflow: hidden; padding: 0; margin: 0;">
                                    <v-list-item
                                      @click="input.allCRMWhatsappContactCRMLocalityIDSelected = !input.allCRMWhatsappContactCRMLocalityIDSelected; input.allCRMWhatsappContactCRMLocalityIDSelected ? input.CRMWhatsappContactCRMLocalityID = systemInformationData.CRMLocalities.map(currentCRMWhatsappContactCRMLocalityID => currentCRMWhatsappContactCRMLocalityID.CRMLocalityID) : input.CRMWhatsappContactCRMLocalityID.length = 0;"
                                      :title="null" 
                                      :subtitle="null"
                                      :active="input.allCRMWhatsappContactCRMLocalityIDSelected"
                                      class="hoverableVListItem"
                                    >
                                      <template v-slot:prepend>
                                        <v-switch
                                          :model-value="input.allCRMWhatsappContactCRMLocalityIDSelected"
                                          density="compact"
                                          color="indigo"
                                          readonly
                                          hide-details
                                          class="hoverableVIcon"
                                          style="margin-right: 20px;"
                                        ></v-switch>
                                        <template v-if="input.allCRMWhatsappContactCRMLocalityIDSelected">
                                          <p>Deseleccionar todas las localidades</p>
                                        </template>
                                        <template v-else>
                                          <p>Seleccionar {{ (systemInformationData.CRMLocalities.length - input.CRMWhatsappContactCRMLocalityID.length) == 1 ? 'la' : 'las' }}{{ (systemInformationData.CRMLocalities.length - input.CRMWhatsappContactCRMLocalityID.length) > 1 ? ` ${(systemInformationData.CRMLocalities.length - input.CRMWhatsappContactCRMLocalityID.length)}` : '' }} localidad{{ (systemInformationData.CRMLocalities.length - input.CRMWhatsappContactCRMLocalityID.length) == 1 ? '' : 'es' }} restante{{ (systemInformationData.CRMLocalities.length - input.CRMWhatsappContactCRMLocalityID.length) == 1 ? '' : 's' }}</p>
                                        </template>
                                      </template>
                                    </v-list-item>
                                  </v-list>
                                </template>
                                <v-list density="compact" style="overflow: hidden; padding: 0; margin: 0;">
                                  <v-list-item 
                                    @click="input.CRMWhatsappContactCRMLocalityID.includes(item.value) ? input.CRMWhatsappContactCRMLocalityID = input.CRMWhatsappContactCRMLocalityID.filter(currentCRMWhatsappContactCRMLocalityID => currentCRMWhatsappContactCRMLocalityID != item.value) : input.CRMWhatsappContactCRMLocalityID.push(item.value); input.allCRMWhatsappContactCRMLocalityIDSelected = input.CRMWhatsappContactCRMLocalityID.length == systemInformationData.CRMLocalities.length;"
                                    :title="null" 
                                    :subtitle="null"
                                    :active="input.CRMWhatsappContactCRMLocalityID.includes(item.value)"
                                    class="hoverableVListItem"
                                  >
                                    <template v-slot:prepend>
                                      <v-checkbox-btn 
                                        :model-value="input.CRMWhatsappContactCRMLocalityID.includes(item.value)"
                                        density="compact"
                                        readonly
                                        hide-details
                                        class="hoverableVIcon"
                                        style="margin-right: 10px;"
                                      ></v-checkbox-btn>
                                    </template>
                                    <v-chip
                                      :color="systemInformationData.CRMLocalities.find(CRMLocality => CRMLocality.CRMLocalityID == item.value) ? systemInformationData.CRMLocalities.find(CRMLocality => CRMLocality.CRMLocalityID == item.value).CRMLocalityColor : 'primary'"
                                      variant="flat"
                                      elevation="2"
                                      density="compact"
                                      label
                                      style="margin-top: 5px; margin-bottom: 5px;"
                                    >
                                      <p>{{ systemInformationData.CRMLocalities.find(CRMLocality => CRMLocality.CRMLocalityID == item.value) ? systemInformationData.CRMLocalities.find(CRMLocality => CRMLocality.CRMLocalityID == item.value).CRMLocalityName : 'No registrada' }}</p>
                                    </v-chip>
                                  </v-list-item>
                                </v-list>
                              </template>
                            </v-autocomplete>
                            <v-autocomplete
                              v-model="input.CRMWhatsappMarketingCampaignMessageCount"
                              :items="display.CRMWhatsappMarketingCampaignMessageCount"
                              :loading="loader.startup || loader.selectCRMWhatsappContactToSendFromCRMWhatsappMarketingCampaignsView || loader.selectCRMWhatsappContactToSendFromCRMWhatsappMarketingCampaignsViewPagination"
                              :disabled="loader.startup || loader.selectCRMWhatsappContactToSendFromCRMWhatsappMarketingCampaignsView || loader.selectCRMWhatsappContactToSendFromCRMWhatsappMarketingCampaignsViewPagination"
                              label="Filtrar por cantidad de mensajes de campañas de marketing"
                              prepend-inner-icon="mdi-numeric"
                              clear-icon="mdi-backspace"
                              variant="outlined"
                              density="compact"
                              autocomplete="off"
                              chips
                              closable-chips
                              clearable
                              hide-details
                              hide-no-data
                              style="margin-bottom: 15px;"
                            >
                              <template v-slot:chip="{ item }">
                                <v-chip color="secondary" elevation="2" variant="flat" label>
                                  <p>{{ item.raw.title }}</p>
                                  <template v-slot:close>
                                    <v-icon 
                                      @click="input.CRMWhatsappMarketingCampaignMessageCount = null"
                                      class="hoverableVIcon"
                                    >
                                      mdi-close-circle
                                    </v-icon>
                                  </template>
                                </v-chip>
                              </template>
                              <template v-slot:item="{ item }">
                                <v-list density="compact" style="overflow: hidden; padding: 0; margin: 0;">
                                  <v-list-item 
                                    @click="input.CRMWhatsappMarketingCampaignMessageCount = item.value"
                                    :title="null" 
                                    :subtitle="null"
                                    :active="input.CRMWhatsappMarketingCampaignMessageCount == item.value"
                                    class="hoverableVListItem"
                                  >
                                    <template v-slot:prepend>
                                      <v-checkbox-btn 
                                        :model-value="input.CRMWhatsappMarketingCampaignMessageCount == item.value"
                                        density="compact"
                                        readonly
                                        hide-details
                                        class="hoverableVIcon"
                                        style="margin-right: 10px;"
                                      ></v-checkbox-btn>
                                    </template>
                                    <p>{{ item.raw.title }}</p>
                                  </v-list-item>
                                </v-list>
                              </template>
                            </v-autocomplete>
                            <v-autocomplete
                              v-model="input.lastCRMWhatsappConversationTime"
                              :items="display.lastTime"
                              :loading="loader.startup || loader.selectCRMWhatsappContactToSendFromCRMWhatsappMarketingCampaignsView || loader.selectCRMWhatsappContactToSendFromCRMWhatsappMarketingCampaignsViewPagination"
                              :disabled="loader.startup || loader.selectCRMWhatsappContactToSendFromCRMWhatsappMarketingCampaignsView || loader.selectCRMWhatsappContactToSendFromCRMWhatsappMarketingCampaignsViewPagination"
                              label="Filtrar por tiempo desde la última conversación"
                              prepend-inner-icon="mdi-chat"
                              clear-icon="mdi-backspace"
                              variant="outlined"
                              density="compact"
                              autocomplete="off"
                              chips
                              closable-chips
                              clearable
                              hide-details
                              hide-no-data
                              style="margin-bottom: 15px;"
                            >
                              <template v-slot:chip="{ item }">
                                <v-chip color="secondary" elevation="2" variant="flat" label>
                                  <p>{{ item.raw.title }}</p>
                                  <template v-slot:close>
                                    <v-icon 
                                      @click="input.lastCRMWhatsappConversationTime = null"
                                      class="hoverableVIcon"
                                    >
                                      mdi-close-circle
                                    </v-icon>
                                  </template>
                                </v-chip>
                              </template>
                              <template v-slot:item="{ item }">
                                <v-list density="compact" style="overflow: hidden; padding: 0; margin: 0;">
                                  <v-list-item 
                                    @click="input.lastCRMWhatsappConversationTime = item.value"
                                    :title="null" 
                                    :subtitle="null"
                                    :active="input.lastCRMWhatsappConversationTime == item.value"
                                    class="hoverableVListItem"
                                  >
                                    <template v-slot:prepend>
                                      <v-checkbox-btn 
                                        :model-value="input.lastCRMWhatsappConversationTime == item.value"
                                        density="compact"
                                        readonly
                                        hide-details
                                        class="hoverableVIcon"
                                        style="margin-right: 10px;"
                                      ></v-checkbox-btn>
                                    </template>
                                    <p>{{ item.raw.title }}</p>
                                  </v-list-item>
                                </v-list>
                              </template>
                            </v-autocomplete>
                            <v-autocomplete
                              v-model="input.lastCRMWhatsappInvoiceTime"
                              :items="display.lastTime"
                              :loading="loader.startup || loader.selectCRMWhatsappContactToSendFromCRMWhatsappMarketingCampaignsView || loader.selectCRMWhatsappContactToSendFromCRMWhatsappMarketingCampaignsViewPagination"
                              :disabled="loader.startup || loader.selectCRMWhatsappContactToSendFromCRMWhatsappMarketingCampaignsView || loader.selectCRMWhatsappContactToSendFromCRMWhatsappMarketingCampaignsViewPagination"
                              label="Filtrar por tiempo desde la última orden"
                              prepend-inner-icon="mdi-invoice-text"
                              clear-icon="mdi-backspace"
                              variant="outlined"
                              density="compact"
                              autocomplete="off"
                              chips
                              closable-chips
                              clearable
                              hide-details
                              hide-no-data
                            >
                              <template v-slot:chip="{ item }">
                                <v-chip color="secondary" elevation="2" variant="flat" label>
                                  <p>{{ item.raw.title }}</p>
                                  <template v-slot:close>
                                    <v-icon 
                                      @click="input.lastCRMWhatsappInvoiceTime = null"
                                      class="hoverableVIcon"
                                    >
                                      mdi-close-circle
                                    </v-icon>
                                  </template>
                                </v-chip>
                              </template>
                              <template v-slot:item="{ item }">
                                <v-list density="compact" style="overflow: hidden; padding: 0; margin: 0;">
                                  <v-list-item 
                                    @click="input.lastCRMWhatsappInvoiceTime = item.value"
                                    :title="null" 
                                    :subtitle="null"
                                    :active="input.lastCRMWhatsappInvoiceTime == item.value"
                                    class="hoverableVListItem"
                                  >
                                    <template v-slot:prepend>
                                      <v-checkbox-btn 
                                        :model-value="input.lastCRMWhatsappInvoiceTime == item.value"
                                        density="compact"
                                        readonly
                                        hide-details
                                        class="hoverableVIcon"
                                        style="margin-right: 10px;"
                                      ></v-checkbox-btn>
                                    </template>
                                    <p>{{ item.raw.title }}</p>
                                  </v-list-item>
                                </v-list>
                              </template>
                            </v-autocomplete>
                          </div>
                          <v-card color="indigo" elevation="0" rounded="0" style="width: 100%; height: 2px; flex-shrink: 0;"></v-card>
                          <v-card color="primary" rounded="0" elevation="0" style="padding: 10px;">
                            <v-btn
                              @click="selectCRMWhatsappContactToSendFromCRMWhatsappMarketingCampaignsView(false)"
                              :disabled="loader.startup || loader.selectCRMWhatsappContactToSendFromCRMWhatsappMarketingCampaignsView || loader.selectCRMWhatsappContactToSendFromCRMWhatsappMarketingCampaignsViewPagination"
                              color="indigo"
                              density="compact"
                              class="hoverableVButton"
                              block
                            >
                              <v-icon size="small" start>mdi-magnify</v-icon>
                              <p style="font-size: small;">BUSCAR</p>
                            </v-btn>
                            <v-btn
                              @click="navigation.filterMenuIsVisible = false; input.CRMWhatsappContactID.length = 0; input.searchedCRMWhatsappContactID = null; input.allCRMWhatsappContactIDSelected = false; input.CRMWhatsappContactNameFirstLetter = null; input.CRMWhatsappContactCRMLocalityID.length = 0; input.allCRMWhatsappContactCRMLocalityIDSelected = false; input.lastCRMWhatsappConversationTime = null; input.lastCRMWhatsappInvoiceTime = null; input.CRMWhatsappMarketingCampaignMessageCount = null; selectCRMWhatsappContactToSendFromCRMWhatsappMarketingCampaignsView(false)"
                              :disabled="loader.startup || loader.selectCRMWhatsappContactToSendFromCRMWhatsappMarketingCampaignsView || loader.selectCRMWhatsappContactToSendFromCRMWhatsappMarketingCampaignsViewPagination"
                              color="secondary"
                              density="compact"
                              class="hoverableVButton"
                              style="margin-top: 10px;"
                              block
                            >
                              <v-icon size="small" start>mdi-backspace</v-icon>
                              <p style="font-size: small;">LIMPIAR</p>
                            </v-btn>
                          </v-card>
                        </v-card>
                      </v-menu>
                      <template v-if="input.CRMWhatsappContactToSend.length > 0">
                        <v-btn
                          @click="input.CRMWhatsappContactToSendPage = 1; navigation.sendCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignsViewDialogIsVisible = true"
                          color="indigo"
                          density="compact"
                          class="hoverableVButton"
                        >
                          <v-icon size="small" start>mdi-account-group</v-icon>
                          <v-icon size="small" start>mdi-bullhorn</v-icon>
                          <v-icon size="small" start>mdi-send</v-icon>
                          <p style="font-size: small;">{{ navigation.CRMWhatsappMarketingCampaignTab == 'Enviar' ? 'ENVIAR' : 'REENVIAR' }} A {{ input.CRMWhatsappContactToSend.length }} CONTACTO{{ input.CRMWhatsappContactToSend.length > 1 ? 'S' : '' }}</p>
                        </v-btn>
                      </template>
                    </div>
                    <div class="paginationContainer">
                      <template v-if="computed_CRMWhatsappContactToSend.length > 0">
                        <v-pagination
                          v-model="navigation.CRMWhatsappContactToSendPage"
                          @update:model-value="selectCRMWhatsappContactToSendFromCRMWhatsappMarketingCampaignsView(false)"
                          :length="Math.ceil(computed_CRMWhatsappContactToSendCount / navigation.CRMWhatsappContactToSendLimit)"
                          :disabled="loader.selectCRMWhatsappContactToSendFromCRMWhatsappMarketingCampaignsViewPagination"
                          :total-visible="3"
                          density="compact"
                          size="small"
                        ></v-pagination>
                        <p style="font-size: x-small;">{{ (computed_CRMWhatsappContactToSendCount == 0) ? '0 de 0 contactos' : `${(navigation.CRMWhatsappContactToSendPage - 1) * navigation.CRMWhatsappContactToSendLimit + 1} - ${Math.min(navigation.CRMWhatsappContactToSendPage * navigation.CRMWhatsappContactToSendLimit, computed_CRMWhatsappContactToSendCount)} de ${computed_CRMWhatsappContactToSendCount} contactos`}}</p>
                      </template>
                    </div>
                  </div>
                </template>
                <div style="height: 60px; display: flex; align-items: center;">
                  <v-tabs
                    v-model="navigation.CRMWhatsappMarketingCampaignTab"
                    density="compact"
                    grow
                    style="height: 100%;"
                  >
                    <template
                      v-for="currentCRMWhatsappMarketingCampaignTab in display.CRMWhatsappMarketingCampaignTab"
                      :key="currentCRMWhatsappMarketingCampaignTab.value"
                    >
                      <v-tab
                        @click="changeCRMWhatsappMarketingCampaignTab(currentCRMWhatsappMarketingCampaignTab.value)"
                        :value="currentCRMWhatsappMarketingCampaignTab.value"
                        :class="navigation.CRMWhatsappMarketingCampaignTab == currentCRMWhatsappMarketingCampaignTab.value ? 'selectedVListItem' : null"
                        class="hoverableVListItem"
                        style="height: 100%;"
                      >
                        <v-icon
                          :size="navigation.CRMWhatsappMarketingCampaignTab == currentCRMWhatsappMarketingCampaignTab.value ? 'large' : null"
                          :color="navigation.CRMWhatsappMarketingCampaignTab == currentCRMWhatsappMarketingCampaignTab.value ? 'indigo' : null"
                          start
                        >
                          {{ currentCRMWhatsappMarketingCampaignTab.icon }}
                        </v-icon>
                        <p
                          :style="navigation.CRMWhatsappMarketingCampaignTab == currentCRMWhatsappMarketingCampaignTab.value ? 'font-weight: bold;' : null"
                        >
                          {{ currentCRMWhatsappMarketingCampaignTab.title }}
                        </p>
                      </v-tab>
                    </template>
                  </v-tabs>
                </div>
              </v-card>
            </template>
            <template v-else-if="computed_CRMWhatsappContactToSendCount == 0">
              <div class="navigationNoContentContainer">
                <v-icon color="indigo">mdi-information</v-icon>
                <p style="margin-top: 5px; color: #9e9e9e;">Selecciona una campaña de marketing para ver su detalle</p>
              </div>
            </template>
          </template>
        </v-card>
      </div>
    </template>
  </div>
</template>

<style scoped>
  .mainContainer {
    display: grid;
    grid-template-columns: 0.25fr 0.75fr;
    min-width: 100%;
    width: 100%;
    max-width: 100%;
    max-height: 100%;
    height: 100%;
    overflow: hidden;
  }
  .navigationContainer {
    display: flex;
    flex-direction: column;
    min-width: 100%;
    width: 100%;
    max-width: 100%;
    min-height: 100%;
    height: 100%;
    max-height: 100%;
    overflow: hidden;
  }
  .navigationContentContainer {
    flex: 1;
    min-width: 100%;
    width: 100%;
    max-width: 100%;
    overflow-y: auto;
    scrollbar-width: thin;
    scrollbar-color: #3F51B5 transparent;
    border-right: 2px solid #343A40;
  }
  .navigationNoContentContainer {
    min-width: 100%;
    width: 100%;
    max-width: 100%;
    min-height: 100%;
    height: 100%;
    max-height: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .paginationContainer {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-left: auto;
    min-width: 0;
    justify-self: end;
  }
  .contentContainer {
    display: flex;
    flex-direction: column;
    min-width: 100%;
    width: 100%;
    max-width: 100%;
    min-height: 100%;
    height: 100%;
    max-height: 100%;
    overflow: hidden;
  }
  .contentContentContainer {
    flex: 1;
    min-width: 100%;
    width: 100%;
    max-width: 100%;
    overflow-y: auto;
    scrollbar-width: thin;
    scrollbar-color: #3F51B5 transparent;
  }
  .twoColumnContainer {
    padding: 15px;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
  }
  .footerContainer {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    align-items: center;
    gap: 15px;
    padding: 15px;
    width: 100%;
    box-sizing: border-box;
  }
  .headerCard {
    padding: 15px;
    display: grid;
    grid-template-columns: 0.7fr 0.3fr;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
  }
  .titleContainer {
    display: flex;
    align-items: center;
  }
  .actionsContainer {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-left: auto;
  }

  @media (max-width: 1200px) {
    .mainContainer {
      min-height: auto;
      height: auto;
      max-height: auto;
      scrollbar-width: thin;
      scrollbar-color: #3F51B5 transparent;
      -ms-overflow-style: none;
      overflow-y: auto;
      grid-template-columns: 1fr;
    }
    .navigationContentContainer {
      max-height: 600px;
    }
    .navigationNoContentContainer {
      height: 600px;
      padding: 15px;
      text-align: center;
    }
    .paginationContainer {
      margin-left: 0;
    }
    .contentContainer {
      height: 800px;
      overflow-y: auto;
      scrollbar-width: thin;
      scrollbar-color: #3F51B5 transparent;
      -ms-overflow-style: none;
    }
    .twoColumnContainer {
      grid-template-columns: 1fr;
    }
    .footerContainer {
      grid-template-columns: 1fr;
    }
    .headerCard {
      grid-template-columns: repeat(1, 1fr);
    }
    .titleContainer {
      justify-content: center;
    }
    .actionsContainer {
      margin-left: 0;
      justify-content: center;
    }
  }
</style>

<script>
  import { systemInformation } from '@/utilities/systemInformation';
  import AppLoaderScreen from '@/components/AppLoaderScreen.vue';
  import { VPie } from 'vuetify/labs/VPie'

  export default {
    inject: ['$generalFunctions', '$displayFunctions'],
    components:
    {
      AppLoaderScreen,
      VPie
    },
    data: () => 
    ({
      input:
      {
        CRMWhatsappMarketingCampaignName: null,
        CRMWhatsappMarketingCampaignDescription: null,
        CRMWhatsappMarketingCampaignType: [],
        allCRMWhatsappMarketingCampaignTypeSelected: false,
        CRMWhatsappMarketingCampaignStatus: [],
        allCRMWhatsappMarketingCampaignStatusSelected: false,
        CRMWhatsappMarketingCampaignCRMLocalityID: [],
        allCRMWhatsappMarketingCampaignCRMLocalityIDSelected: false,
        CRMWhatsappMarketingCampaignCRMWhatsappTextMessageContent: null,
        CRMWhatsappContactID: [],
        searchedCRMWhatsappContactID: null,
        allCRMWhatsappContactIDSelected: false,
        CRMWhatsappContactNameFirstLetter: null,
        CRMWhatsappContactCRMLocalityID: [],
        allCRMWhatsappContactCRMLocalityIDSelected: false,
        lastCRMWhatsappConversationTime: null,
        lastCRMWhatsappInvoiceTime: null,
        CRMWhatsappMarketingCampaignMessageCount: null,
        CRMWhatsappContactToSend: [],
        CRMWhatsappContactToSendPage: 1
      },
      display: 
      {
        CRMWhatsappMarketingCampaign: null,
        currentCRMWhatsappMarketingCampaign: null,
        CRMWhatsappMarketingCampaignType:
        [
          {title: 'Difusión', value: 'Difusión', color: 'teal'},
          {title: 'Promoción', value: 'Promoción', color: 'info'},
          {title: 'Código de descuento', value: 'Código de descuento', color: 'warning'},
          {title: 'Otro', value: 'Otro', color: 'blue-grey'}
        ],
        CRMWhatsappMarketingCampaignStatus:
        [
          {title: 'Activa', value: 'Activa', color: 'success'},
          {title: 'Inactiva', value: 'Inactiva', color: 'grey'},
          {title: 'Finalizada', value: 'Finalizada', color: 'error'}
        ],
        CRMWhatsappContact: [],
        CRMWhatsappContactToSendHeaders: [],
        CRMWhatsappContactToSend: null,
        CRMWhatsappContactAutocomplete: [],
        CRMWhatsappContactNameFirstLetter:
        [
          {title: 'A', value: 'A'},
          {title: 'B', value: 'B'},
          {title: 'C', value: 'C'},
          {title: 'D', value: 'D'},
          {title: 'E', value: 'E'},
          {title: 'F', value: 'F'},
          {title: 'G', value: 'G'},
          {title: 'H', value: 'H'},
          {title: 'I', value: 'I'},
          {title: 'J', value: 'J'},
          {title: 'K', value: 'K'},
          {title: 'L', value: 'L'},
          {title: 'M', value: 'M'},
          {title: 'N', value: 'N'},
          {title: 'O', value: 'O'},
          {title: 'P', value: 'P'},
          {title: 'Q', value: 'Q'},
          {title: 'R', value: 'R'},
          {title: 'S', value: 'S'},
          {title: 'T', value: 'T'},
          {title: 'U', value: 'U'},
          {title: 'V', value: 'V'},
          {title: 'W', value: 'W'},
          {title: 'X', value: 'X'},
          {title: 'Y', value: 'Y'},
          {title: 'Z', value: 'Z'},
          {title: 'Otro', value: 'Otro'}
        ],
        lastTime:
        [
          {title: '1 día', value: 1440},
          {title: '3 días', value: 4320},
          {title: '1 semana', value: 10080},
          {title: '2 semanas', value: 20160},
          {title: '1 mes', value: 43200},
          {title: '2 meses', value: 86400},
          {title: '3 meses', value: 129600},
          {title: '6 meses', value: 259200},
          {title: '1 año', value: 525600}
        ],
        CRMWhatsappMarketingCampaignMessageCount:
        [
          {title: 'Sin mensajes de campañas de marketing', value: 0},
          {title: '5 o menos mensajes de campañas de marketing', value: 5},
          {title: '10 o menos mensajes de campañas de marketing', value: 10},
          {title: '25 o menos mensajes de campañas de marketing', value: 25},
          {title: '50 o menos mensajes de campañas de marketing', value: 50},
          {title: '100 o menos mensajes de campañas de marketing', value: 100}
        ],
        CRMWhatsappMarketingCampaignTab:
        [
          {title: 'Información', value: 'Información', icon: 'mdi-information'},
          {title: 'Enviar', value: 'Enviar', icon: 'mdi-send'},
          {title: 'Enviados', value: 'Enviados', icon: 'mdi-clock'}
        ]
      },
      navigation: 
      {
        errorOnStartup: false,
        mainMenuIsVisible: false,
        CRMWhatsappMarketingCampaignPage: 1,
        CRMWhatsappMarketingCampaignLimit: 100,
        CRMWhatsappContactToSendPage: 1,
        CRMWhatsappContactToSendLimit: 100,
        currentCRMWhatsappMarketingCampaignID: null,
        CRMWhatsappMarketingCampaignTab: null,
        contextMenuIsVisible: false,
        contextMenuY: 0,
        contextMenuX: 0,
        contextMenuItem: null,
        filterMenuIsVisible: false,
        sendCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignsViewDialogIsVisible: false
      },
      loader: 
      {
        startup: false,
        selectCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignsView: false,
        selectCRMWhatsappMarketingCampaignDetailFromCRMWhatsappMarketingCampaignsView: false,
        selectCRMWhatsappContactToSendFromCRMWhatsappMarketingCampaignsView: false,
        selectCRMWhatsappContactToSendFromCRMWhatsappMarketingCampaignsViewPagination: false,
        sendCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignsView: false
      },
      interval:
      {
        mainInterval: null
      },
      systemInformationData: 
      {
        CRMAccountID: null,
        CRMLocalities: null,
        CRMAgent: null,
        CRMAgents: null,
        tooltipDisabled: null,
        updateSubscription: null
      }
    }),

    computed:
    {
      computed_CRMWhatsappMarketingCampaignCount(){
        if (this.display.CRMWhatsappMarketingCampaign == null) return 0;
        else return this.display.CRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignCount;
      },
      computed_CRMWhatsappMarketingCampaign(){
        if (this.display.CRMWhatsappMarketingCampaign == null) return [];
        else return this.display.CRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaign;
      },
      computed_CRMWhatsappContactToSendCount(){
        if (this.display.CRMWhatsappContactToSend == null) return 0;
        else return this.display.CRMWhatsappContactToSend.CRMWhatsappContactToSendCount;
      },
      computed_CRMWhatsappContactToSend(){
        if (this.display.CRMWhatsappContactToSend == null) return [];
        else return this.display.CRMWhatsappContactToSend.CRMWhatsappContactToSend;
      },
      computed_CRMWhatsappContactToSendHeaders(){
        return this.display.CRMWhatsappContactToSendHeaders.slice().sort((CRMWhatsappContactToSendHeaderA, CRMWhatsappContactToSendHeaderB) => CRMWhatsappContactToSendHeaderA.index - CRMWhatsappContactToSendHeaderB.index);
      },
      computed_CRMWhatsappContact(){
        if (this.input.searchedCRMWhatsappContactID == null) return this.display.CRMWhatsappContact.slice(0, 250);
        else return this.display.CRMWhatsappContact.filter(currentDisplayCRMWhatsappContact =>
          currentDisplayCRMWhatsappContact.CRMWhatsappContactID.toString().includes(this.input.searchedCRMWhatsappContactID)
          ||
          currentDisplayCRMWhatsappContact.CRMWhatsappContactName.toLowerCase().includes(this.input.searchedCRMWhatsappContactID.toLowerCase())
          ||
          currentDisplayCRMWhatsappContact.CRMWhatsappContactPhoneNumber.toLowerCase().includes(this.input.searchedCRMWhatsappContactID.toLowerCase())
        ).slice(0, 250);
      },
    },

    methods:
    {
      async selectCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignsView(isNewSearch){
        this.loader.selectCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignsView = true;
        this.display.currentCRMWhatsappMarketingCampaign = null;
        this.navigation.currentCRMWhatsappMarketingCampaignID = null;
        if (isNewSearch) this.navigation.CRMWhatsappMarketingCampaignPage = 1;
        const selectCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignsViewRequestBody =
        {
          'localStorage':
          {
            'CRMAccountID': this.systemInformationData.CRMAccountID
          },
          'CRMWhatsappMarketingCampaignName': this.input.CRMWhatsappMarketingCampaignName,
          'CRMWhatsappMarketingCampaignDescription': this.input.CRMWhatsappMarketingCampaignDescription,
          'CRMWhatsappMarketingCampaignType': this.input.CRMWhatsappMarketingCampaignType,
          'CRMWhatsappMarketingCampaignStatus': this.input.CRMWhatsappMarketingCampaignStatus,
          'CRMWhatsappMarketingCampaignCRMLocalityID': this.input.CRMWhatsappMarketingCampaignCRMLocalityID,
          'CRMWhatsappMarketingCampaignCRMWhatsappTextMessageContent': this.input.CRMWhatsappMarketingCampaignCRMWhatsappTextMessageContent,
          'CRMWhatsappMarketingCampaignPage': this.navigation.CRMWhatsappMarketingCampaignPage,
          'CRMWhatsappMarketingCampaignLimit': this.navigation.CRMWhatsappMarketingCampaignLimit
        };
        const selectCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignsViewResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMWhatsappMarketingCampaign/functions/selectCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignsView', selectCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignsViewRequestBody);
        if (selectCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignsViewResult.success){
          this.display.CRMWhatsappMarketingCampaign = selectCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignsViewResult.result;
          this.navigation.mainMenuIsVisible = false;
        } else {
          this.navigation.errorOnStartup = true;
          this.$root.notificationDialog.showSystemNotificationDialog('selectCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignsView_error', 'error', 'Ha ocurrido un error inesperado al consultar las campañas de marketing, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
        }
        this.loader.selectCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignsView = false;
      },
      async selectCRMWhatsappContactForInput(){
        const selectCRMWhatsappContactForInputRequestQuery =
        {
          'localStorage':
          {
            'CRMAccountID': this.systemInformationData.CRMAccountID
          }
        };
        const selectCRMWhatsappContactForInputResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMWhatsappContact/functions/selectCRMWhatsappContactForInput', selectCRMWhatsappContactForInputRequestQuery);
        if (selectCRMWhatsappContactForInputResult.success) this.display.CRMWhatsappContact = selectCRMWhatsappContactForInputResult.result;
        else {
          this.navigation.errorOnStartup = true;
          this.$root.notificationDialog.showSystemNotificationDialog('selectCRMWhatsappContactForInput_error', 'error', 'Ha ocurrido un error inesperado al consultar el contacto, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
        }
      },
      async selectCRMWhatsappMarketingCampaignDetailFromCRMWhatsappMarketingCampaignsView(CRMWhatsappMarketingCampaignID){
        this.loader.selectCRMWhatsappMarketingCampaignDetailFromCRMWhatsappMarketingCampaignsView = true;
        this.navigation.currentCRMWhatsappMarketingCampaignID = CRMWhatsappMarketingCampaignID;
        const selectCRMWhatsappMarketingCampaignDetailFromCRMWhatsappMarketingCampaignsViewRequestBody =
        {
          'localStorage':
          {
            'CRMAccountID': this.systemInformationData.CRMAccountID
          },
          'CRMWhatsappMarketingCampaignID': CRMWhatsappMarketingCampaignID,
          'CRMWhatsappContactToSendPage': this.navigation.CRMWhatsappContactToSendPage,
          'CRMWhatsappContactToSendLimit': this.navigation.CRMWhatsappContactToSendLimit
        };
        const selectCRMWhatsappMarketingCampaignDetailFromCRMWhatsappMarketingCampaignsViewResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMWhatsappMarketingCampaign/functions/selectCRMWhatsappMarketingCampaignDetailFromCRMWhatsappMarketingCampaignsView', selectCRMWhatsappMarketingCampaignDetailFromCRMWhatsappMarketingCampaignsViewRequestBody);
        if (selectCRMWhatsappMarketingCampaignDetailFromCRMWhatsappMarketingCampaignsViewResult.success){
          this.navigation.CRMWhatsappMarketingCampaignTab = 'Información';
          this.display.currentCRMWhatsappMarketingCampaign = selectCRMWhatsappMarketingCampaignDetailFromCRMWhatsappMarketingCampaignsViewResult.result;
        } else {
          this.navigation.currentCRMWhatsappMarketingCampaignID = null;
          this.display.currentCRMWhatsappMarketingCampaign = null;
          this.$root.notificationDialog.showSystemNotificationDialog('selectCRMWhatsappMarketingCampaignDetailFromCRMWhatsappMarketingCampaignsView_error', 'error', 'Ha ocurrido un error inesperado al consultar la campaña de marketing, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
        }
        this.loader.selectCRMWhatsappMarketingCampaignDetailFromCRMWhatsappMarketingCampaignsView = false;
      },
      async selectCRMWhatsappContactToSendFromCRMWhatsappMarketingCampaignsView(isNewSearch){
        if (isNewSearch){
          this.input.CRMWhatsappContactID.length = 0;
          this.input.CRMWhatsappContactNameFirstLetter = null;
          this.input.CRMWhatsappContactCRMLocalityID.length = 0;
          this.input.lastCRMWhatsappConversationTime = null;
          this.input.lastCRMWhatsappInvoiceTime = null;
          this.navigation.CRMWhatsappContactToSendPage = 1;
          this.loader.selectCRMWhatsappContactToSendFromCRMWhatsappMarketingCampaignsView = true;
        }
        this.loader.selectCRMWhatsappContactToSendFromCRMWhatsappMarketingCampaignsViewPagination = true;
        const selectCRMWhatsappContactToSendFromCRMWhatsappMarketingCampaignsViewRequestBody =
        {
          'localStorage':
          {
            'CRMAccountID': this.systemInformationData.CRMAccountID
          },
          'CRMWhatsappMarketingCampaignID': this.display.currentCRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignID,
          'CRMWhatsappContactID': this.input.CRMWhatsappContactID,
          'CRMWhatsappContactNameFirstLetter': this.input.CRMWhatsappContactNameFirstLetter,
          'CRMWhatsappContactCRMLocalityID': this.input.CRMWhatsappContactCRMLocalityID,
          'lastCRMWhatsappConversationTime': this.input.lastCRMWhatsappConversationTime,
          'lastCRMWhatsappInvoiceTime': this.input.lastCRMWhatsappInvoiceTime,
          'CRMWhatsappMarketingCampaignMessageCount': this.input.CRMWhatsappMarketingCampaignMessageCount,
          'CRMWhatsappContactToSendPage': this.navigation.CRMWhatsappContactToSendPage,
          'CRMWhatsappContactToSendLimit': this.navigation.CRMWhatsappContactToSendLimit,
          'sent': this.navigation.CRMWhatsappMarketingCampaignTab == 'Enviados'
        };
        const selectCRMWhatsappContactToSendFromCRMWhatsappMarketingCampaignsViewResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMWhatsappMarketingCampaign/functions/selectCRMWhatsappContactToSendFromCRMWhatsappMarketingCampaignsView', selectCRMWhatsappContactToSendFromCRMWhatsappMarketingCampaignsViewRequestBody);
        if (selectCRMWhatsappContactToSendFromCRMWhatsappMarketingCampaignsViewResult.success){
          this.display.CRMWhatsappContactToSend = selectCRMWhatsappContactToSendFromCRMWhatsappMarketingCampaignsViewResult.result;
          await this.prepareTables();
          this.launchMainInterval();
        }
        else {
          this.navigation.CRMWhatsappMarketingCampaignTab = 'Información';
          this.$root.notificationDialog.showSystemNotificationDialog('selectCRMWhatsappContactToSendFromCRMWhatsappMarketingCampaignsView_error', 'error', 'Ha ocurrido un error inesperado al consultar los contactos a enviar, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
        }
        this.navigation.filterMenuIsVisible = false;
        this.loader.selectCRMWhatsappContactToSendFromCRMWhatsappMarketingCampaignsView = false;
        this.loader.selectCRMWhatsappContactToSendFromCRMWhatsappMarketingCampaignsViewPagination = false;
      },
      async sendCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignsView(){
        this.loader.sendCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignsView = true;
        const sendCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignsViewRequestBody =
        {
          'localStorage':
          {
            'CRMAccountID': this.systemInformationData.CRMAccountID,
            'CRMAgentID': this.systemInformationData.CRMAgent.CRMAgentID
          },
          'CRMWhatsappMarketingCampaignID': this.display.currentCRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignID,
          'CRMWhatsappContactID': this.input.CRMWhatsappContactToSend.map(currentCRMWhatsappContactToSend => currentCRMWhatsappContactToSend.CRMWhatsappContactID)
        };
        const sendCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignsViewResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMWhatsappMarketingCampaign/functions/sendCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignsView', sendCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignsViewRequestBody);
        if (sendCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignsViewResult.success){
          this.$root.notificationDialog.showSystemNotificationDialog('sendCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignsView_success', 'success', `Se ha enviado la campaña de marketing ${this.display.currentCRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignID} a ${sendCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignsViewResult.result} contacto${sendCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignsViewResult.result > 1 ? 's' : ''} de ${this.input.CRMWhatsappContactToSend.length} contacto${this.input.CRMWhatsappContactToSend.length > 1 ? 's' : ''} exitosamente`, null, true);
          this.navigation.sendCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignsViewDialogIsVisible = false;
          await this.selectCRMWhatsappContactToSendFromCRMWhatsappMarketingCampaignsView(true);
          this.input.CRMWhatsappContactToSend.length = 0;
        } else this.$root.notificationDialog.showSystemNotificationDialog('sendCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignsView_error', 'error', 'Ha ocurrido un error inesperado al enviar la campaña de marketing, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
        this.loader.sendCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignsView = false;
      },
      changeCRMWhatsappMarketingCampaignTab(CRMWhatsappMarketingCampaignTab){
        this.input.CRMWhatsappContactID.length = 0;
        this.input.searchedCRMWhatsappContactID = null;
        this.input.allCRMWhatsappContactIDSelected = false;
        this.input.CRMWhatsappContactNameFirstLetter = null;
        this.input.CRMWhatsappContactCRMLocalityID.length = 0;
        this.input.allCRMWhatsappContactCRMLocalityIDSelected = false;
        this.input.lastCRMWhatsappConversationTime = null;
        this.input.lastCRMWhatsappInvoiceTime = null;
        this.input.CRMWhatsappMarketingCampaignMessageCount = null;
        this.input.CRMWhatsappContactToSend.length = 0;
        if (CRMWhatsappMarketingCampaignTab == 'Información') this.selectCRMWhatsappMarketingCampaignDetailFromCRMWhatsappMarketingCampaignsView(this.display.currentCRMWhatsappMarketingCampaign.CRMWhatsappMarketingCampaignID);
        if (['Enviar', 'Enviados'].includes(CRMWhatsappMarketingCampaignTab)) this.selectCRMWhatsappContactToSendFromCRMWhatsappMarketingCampaignsView(true);
      },
      getTableRowClass(table, item){
        if (table == 'CRMWhatsappContactToSend'){
          if (this.loader.selectCRMWhatsappContactToSendFromCRMWhatsappMarketingCampaignsViewPagination) return 'loadingVDataTableRow';
          if (this.input.CRMWhatsappContactToSend.find(currentCRMWhatsappContactToSend => currentCRMWhatsappContactToSend.CRMWhatsappContactID == item.CRMWhatsappContactID) != null) return 'selectedVDataTableRow';
        }
        return null;
      },
      launchMainInterval(){
        if (this.interval.mainInterval) clearInterval(this.interval.mainInterval);
        const mainInterval = () => {
          if (this.display.CRMWhatsappContactToSend != null){
            this.display.CRMWhatsappContactToSend.CRMWhatsappContactToSend.forEach(currentCRMWhatsappContactToSend => {
              if (currentCRMWhatsappContactToSend.lastCRMWhatsappConversationStartDatetime) currentCRMWhatsappContactToSend.lastCRMWhatsappConversationStartDatetimeTranscurredSeconds = (new Date() - new Date(currentCRMWhatsappContactToSend.lastCRMWhatsappConversationStartDatetime)) / 1000;
              if (currentCRMWhatsappContactToSend.lastCRMWhatsappInvoiceCreationDatetime) currentCRMWhatsappContactToSend.lastCRMWhatsappInvoiceCreationDatetimeTranscurredSeconds = (new Date() - new Date(currentCRMWhatsappContactToSend.lastCRMWhatsappInvoiceCreationDatetime)) / 1000;
              if (currentCRMWhatsappContactToSend.lastCRMWhatsappMarketingCampaignMessageSendAPIDatetime) currentCRMWhatsappContactToSend.lastCRMWhatsappMarketingCampaignMessageSendAPIDatetimeTranscurredSeconds = (new Date() - new Date(currentCRMWhatsappContactToSend.lastCRMWhatsappMarketingCampaignMessageSendAPIDatetime)) / 1000;
              if (currentCRMWhatsappContactToSend.lastCRMWhatsappMarketingCampaignMessageDeliveredAPIDatetime) currentCRMWhatsappContactToSend.lastCRMWhatsappMarketingCampaignMessageDeliveredAPIDatetimeTranscurredSeconds = (new Date() - new Date(currentCRMWhatsappContactToSend.lastCRMWhatsappMarketingCampaignMessageDeliveredAPIDatetime)) / 1000;
              if (currentCRMWhatsappContactToSend.lastCRMWhatsappMarketingCampaignMessageReadAPIDatetime) currentCRMWhatsappContactToSend.lastCRMWhatsappMarketingCampaignMessageReadAPIDatetimeTranscurredSeconds = (new Date() - new Date(currentCRMWhatsappContactToSend.lastCRMWhatsappMarketingCampaignMessageReadAPIDatetime)) / 1000;
            });
          }
        };
        mainInterval();
        this.interval.mainInterval = setInterval(mainInterval, 1000);
      },
      async prepareTables(){
        const CRMWhatsappContactToSendHeaders = 
        [
          {title: null, value: 'select', icon: null, visible: true},
          {title: 'ID', value: 'CRMWhatsappContactID', icon: 'mdi-barcode', visible: true},
          {title: 'CONTACTO', value: 'CRMWhatsappContact', icon: 'mdi-account', visible: true},
          {title: 'LOCALIDAD', value: 'CRMWhatsappContactCRMLocality', icon: 'mdi-store', visible: true},
          ...(this.navigation.CRMWhatsappMarketingCampaignTab == 'Enviados' ? [{title: 'MENSAJE', value: 'CRMWhatsappMarketingCampaignMessage', icon: 'mdi-message-text', visible: true}] : []),
          {title: 'ULTIMA CONVERSACIÓN', value: 'lastCRMWhatsappConversationStartDatetime', icon: 'mdi-chat', visible: true},
          {title: 'ULTIMA ORDEN', value: 'lastCRMWhatsappInvoiceCreationDatetime', icon: 'mdi-invoice-text', visible: true},
          ...(this.navigation.CRMWhatsappMarketingCampaignTab == 'Enviar' ? [{title: 'CANTIDAD DE MENSAJES', value: 'CRMWhatsappMarketingCampaignMessageCount', icon: 'mdi-numeric', visible: true}] : [])
        ].map((header, index) => ({ ...header, index: index }));
        let localStorageHeaders = JSON.parse(localStorage.getItem('CRMWhatsappMarketingCampaignsView_CRMWhatsappContactToSendHeaders') || JSON.stringify(CRMWhatsappContactToSendHeaders));
        for (const localStorageHeader of localStorageHeaders){
          const CRMWhatsappContactToSendHeader = CRMWhatsappContactToSendHeaders.find(CRMWhatsappContactToSendHeader => CRMWhatsappContactToSendHeader.value == localStorageHeader.value);
          if (CRMWhatsappContactToSendHeader){
            if (localStorageHeader.visible != null) CRMWhatsappContactToSendHeader.visible = localStorageHeader.visible;
            if (localStorageHeader.index != null) CRMWhatsappContactToSendHeader.index = localStorageHeader.index;
          }
        }
        this.display.CRMWhatsappContactToSendHeaders = CRMWhatsappContactToSendHeaders.slice().sort((CRMWhatsappContactToSendHeaderA, CRMWhatsappContactToSendHeaderB) => CRMWhatsappContactToSendHeaderA.index - CRMWhatsappContactToSendHeaderB.index);
      },
      async getSystemInformationData(){
        try { 
          systemInformation.setGeneralFunctions(this.$generalFunctions.default);
          const systemInformationResult = await systemInformation.startup();
          if (systemInformationResult.success){
            this.systemInformationData.CRMAccountID = systemInformation.getCRMAccountID;
            this.systemInformationData.CRMLocalities = systemInformation.getCRMLocalities;
            this.systemInformationData.CRMAgent = systemInformation.getCRMAgent;
            this.systemInformationData.CRMAgents = systemInformation.getCRMAgents;
            this.systemInformationData.tooltipDisabled = systemInformation.getTooltipDisabled;
            this.systemInformationData.updateSubscription = systemInformation.subscribeToUpdate((updatedSystemInformation) => {
              this.systemInformationData.tooltipDisabled = updatedSystemInformation.tooltipDisabled;
            });
          } else {
            this.navigation.errorOnStartup = true;
            this.$root.notificationDialog.showSystemNotificationDialog('getSystemInformationData_error', 'error', 'Ha ocurrido un error inesperado al obtener la información del sistema, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, false);
          }
        } catch {
          this.navigation.errorOnStartup = true;
          this.$root.notificationDialog.showSystemNotificationDialog('getSystemInformationData_error', 'error', 'Ha ocurrido un error inesperado al obtener la información del sistema, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, false);
        }
      }

    },
    async mounted(){
      this.loader.startup = true;
      await this.getSystemInformationData();
      await this.prepareTables();
      await Promise.all([
        this.selectCRMWhatsappContactForInput(),
        this.selectCRMWhatsappMarketingCampaignFromCRMWhatsappMarketingCampaignsView(true)
      ]);
      if (this.navigation.errorOnStartup == false) this.loader.startup = false;
    },
    beforeUnmount(){
      if (this.interval.mainInterval) clearInterval(this.interval.mainInterval);
      this.interval.mainInterval = null;
      if (this.systemInformationData.updateSubscription)systemInformation.unsubscribeFromUpdate(this.systemInformationData.updateSubscription);
      this.systemInformationData.updateSubscription = null;
    }
  }
</script>